/* eslint-disable */
import React from "react";


const ADMIN_EMAIL = "admin@veritascruda.com";
const ADMIN_PASSWORD = "G@ssword2983";
const GUEST_SEARCH_LIMIT = 3;
const GUEST_SEARCH_KEY = "vc_guest_searches";
const REPORTS_STORAGE_KEY = "vc_reports";
const VIOLATIONS_STORAGE_KEY = "vc_violations";
const JOURNAL_STORAGE_KEY = "vc_journal_entries";
const SAVED_POSTS_KEY = "vc_saved_posts";
const RATE_LIMIT_KEY = "vc_rate_limits";
const ONBOARDING_KEY = "vc_onboarding_done";

const BADGE_TIERS = [
  { id:"truth_seeker",   label:"Truth Seeker",       icon:"🔍", minScore:0   },
  { id:"freedom_hunter", label:"Freedom Hunter",      icon:"🏹", minScore:10  },
  { id:"historian",      label:"Historian",           icon:"⚔️", minScore:50  },
  { id:"keeper",         label:"Keeper of the Flame", icon:"🔥", minScore:150 },
];
function getBadge(score) {
  let badge = BADGE_TIERS[0];
  for (const t of BADGE_TIERS) { if (score >= t.minScore) badge = t; }
  return badge;
}

const WELCOME_POST = {
  id:"welcome-viveliber", name:"Jacks Liver", handle:"@ViveLiber", avatar:"👑",
  isOrg:false, isAdmin:true, time:"founder",
  body:"I created VERITAS CRUDA for true freedom of speech. You can post and say whatever is on your mind be it rude or disrespectful it does not matter. Racism, threats of violence or anyone found to be associated with terrorism will be immediately banned. Respect is subjective to a certain extent and as such if you cannot handle what people say then you are weak.",
  likes:0, reposts:0, comments:0, liked:false, hasImage:false, pinned:true,
};

const ONBOARDING_STEPS = [
  { title:"Welcome to Veritas Cruda", body:"The platform built on true freedom of speech. No algorithm manipulating what you see. No data sold. No censorship beyond three hard rules. What you say is yours. What you see is real." },
  { title:"The Three Hard Rules", body:"Racism and hate speech, direct threats of violence, CSAM, and terrorism-affiliated content are the only things prohibited. Everything else is the sole responsibility of the person who posts it. Thick skin is required here." },
  { title:"Tagging and the Feed", body:"Use @handle to tag anyone in a post. A dropdown will appear as you type. Your feed is chronological by default. Toggle between Latest and For You at the top of the feed." },
  { title:"Your Private Journal", body:"AES-256 encrypted in your browser. Not even Veritas Cruda can read your entries. Your passphrase never leaves your device. If you forget it no one can recover your entries. That is the price of true privacy." },
  { title:"Full Picture", body:"Type any topic and get only verified sourced facts stripped of spin from every side. No opinions. No agendas. Just what is known to be true with a source link for every claim." },
  { title:"Daily Freedom Challenge", body:"Every day at midnight a new question about freedom and world history is posted. Answer correctly submit real examples earn your title from Truth Seeker to Keeper of the Flame." },
  { title:"Personalize Your Profile", body:"Upload a profile photo and banner edit your bio choose from 20 fonts pick an accent color set a layout add background music and pin your best post. Advanced users can use the CSS editor for deep customization." },
  { title:"Reporting and Safety", body:"Every post has a Report button. Submit a link or screenshot. Admin reviews all reports. Three verified violations result in a permanent ban. Account deleted. No warning. No appeal." },
  { title:"TRIBUNA", body:"A YouTube-style video platform inside Veritas Cruda. Upload videos build your Voice page grow your audience earn fair revenue. You keep the majority. Physical awards ship when you hit follower milestones." },
  { title:"You are Ready", body:"That is everything you need to know. Return to this tutorial anytime from your profile settings. Now go speak the raw truth." },
];

const TOS_TEXT = `VERITAS CRUDA TERMS OF SERVICE
Effective Date: April 12, 2026

1. ACCEPTANCE OF TERMS
By accessing or using Veritas Cruda you agree to be bound by these Terms of Service.

2. THICK SKIN REQUIREMENT
Veritas Cruda is a platform for true freedom of speech. You will encounter content that is offensive, disagreeable, rude, or uncomfortable. This is the platform working as intended. If you cannot handle unfiltered human expression this platform is not for you.

3. USER RESPONSIBILITY
You are solely and entirely responsible for your own actions on the Platform. Veritas Cruda is a platform, not a participant. We do not endorse, verify, or take responsibility for any user-generated content or user behavior.

4. LIMITATION OF LIABILITY
TO THE FULLEST EXTENT PERMITTED BY LAW VERITAS CRUDA AND ITS AFFILIATES SHALL NOT BE HELD LIABLE for any actions, conduct, or content of its users or any harm resulting from user interactions. You use the Platform at your own risk.

5. PROHIBITED CONTENT
The only content strictly prohibited is:
- Child sexual abuse material (CSAM) of any kind
- Racist content, slurs, or hate speech targeting individuals or groups based on race or ethnicity
- Direct threats of violence against a specific individual or group
- Content promoting, glorifying, or associated with terrorism or terrorist organizations

6. DATA PLEDGE - ABSOLUTE AND IRREVOCABLE
Veritas Cruda will NEVER sell, share, license, or transfer your private data to any third party under any circumstances. Not to advertisers. Not to governments. Not to AI companies. Not to data brokers. Not to anyone. Ever. This is a founding principle that cannot be changed. Your data belongs to you.

7. HARASSMENT REPORTING AND BLOCK SYSTEM
a) Reports must include a direct link to offending content OR a screenshot for private messages plus a written description.
b) All reports are reviewed by platform administration.
c) 1st and 2nd violations result in 24-hour account restrictions.
d) 3rd violation results in permanent ban - account immediately and permanently deleted without warning notification or appeal.
e) Permanently banned users are subject to device fingerprint and IP banning.
f) Permanent bans are final. No appeal.

8. TAGGING
Users may tag other users using the @ symbol. Tagging used in a pattern of targeted harassment is subject to the reporting process.

9. ANONYMOUS POSTING
Users may post anonymously. Anonymous posts are still subject to all platform rules. Platform administration can identify the true account behind any anonymous post.

10. RATE LIMITING
Reasonable posting limits are enforced to prevent spam and abuse.

11. PARENTAL CONTROLS
a) Accounts for users under 16 may have parental controls activated during signup.
b) Parental controls filter all content not suitable for minors.
c) Controls automatically and permanently lift on the users 16th birthday.
d) Parents may remove controls early via PIN or linked parent account.
e) Parent accounts may read a childs journal until the child turns 16 after which access is permanently revoked.
f) Journal downloads are unavailable until age 16.

12. AGE-BASED EXPERIENCE
Users under 13 receive a simplified fully filtered experience. Users 13-14 receive a moderate filter. Users 15 receive the full Veritas Cruda theme with content filtering. Users 16 and older receive full platform access with no restrictions.

13. DECEPTIVE ADVERTISING
Any organization or individual found running deceptive advertisements faces immediate permanent ban with no warning and no appeal. Users may report deceptive ads via the report button on any promoted post.

14. VOICE REVENUE SHARING
When monetization launches Voices retain the majority of revenue earned through their content. Veritas Cruda retains a small platform fee. Splits are transparent.

15. VOICE ACHIEVEMENT AWARDS - THE EAGLE AND THE CHAIN
Bronze Eagle: 1000 followers. Silver Eagle: 10000 followers. Gold Eagle: 100000 followers. Sovereign Eagle: 1000000 followers with a personal email from @ViveLiber. The Unchained Eagle: awarded solely at the discretion of @ViveLiber and delivered in person by @ViveLiber to Voices who embody the mission of Veritas Cruda. This award cannot be earned by numbers alone ever.

16. CONTENT OWNERSHIP
You retain ownership of all content you post.

17. GDPR COMPLIANCE
European users have the right to erasure data portability and access to their personal data.

18. COPPA COMPLIANCE
Veritas Cruda complies with COPPA. Accounts for users under 13 require verified parental consent.

19. TERMINATION
Veritas Cruda reserves the right to suspend or terminate any account at any time for any reason.

20. GOVERNING LAW
These Terms shall be governed by the laws of the United States.

By creating an account you acknowledge that you have read understood and agree to these Terms. You accept full responsibility for your actions on this Platform.

VERITAS CRUDA - The Raw Truth, Unfiltered`;



// ─── Encryption ────────────────────────────────────────────────────────────────
async function deriveKey(password, salt) {
  const enc = new TextEncoder();
  const km = await window.crypto.subtle.importKey("raw", enc.encode(password), "PBKDF2", false, ["deriveKey"]);
  return window.crypto.subtle.deriveKey({ name:"PBKDF2", salt, iterations:100000, hash:"SHA-256" }, km, { name:"AES-GCM", length:256 }, false, ["encrypt","decrypt"]);
}
async function encryptText(plaintext, password) {
  const enc = new TextEncoder();
  const salt = window.crypto.getRandomValues(new Uint8Array(16));
  const iv   = window.crypto.getRandomValues(new Uint8Array(12));
  const key  = await deriveKey(password, salt);
  const cipher = await window.crypto.subtle.encrypt({ name:"AES-GCM", iv }, key, enc.encode(plaintext));
  const combined = new Uint8Array(16 + 12 + cipher.byteLength);
  combined.set(salt,0); combined.set(iv,16); combined.set(new Uint8Array(cipher),28);
  return btoa(String.fromCharCode(...combined));
}
async function decryptText(base64, password) {
  const bytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
  const key = await deriveKey(password, bytes.slice(0,16));
  const plain = await window.crypto.subtle.decrypt({ name:"AES-GCM", iv:bytes.slice(16,28) }, key, bytes.slice(28));
  return new TextDecoder().decode(plain);
}

// ─── Storage ────────────────────────────────────────────────────────────────────
function loadReports()     { try { return JSON.parse(localStorage.getItem(REPORTS_STORAGE_KEY)    || "[]");  } catch { return []; } }
function saveReports(r)    { localStorage.setItem(REPORTS_STORAGE_KEY,    JSON.stringify(r)); }
function loadViolations()  { try { return JSON.parse(localStorage.getItem(VIOLATIONS_STORAGE_KEY) || "{}");  } catch { return {}; } }
function saveViolations(v) { localStorage.setItem(VIOLATIONS_STORAGE_KEY, JSON.stringify(v)); }
function loadJournal()     { try { return JSON.parse(localStorage.getItem(JOURNAL_STORAGE_KEY)    || "[]");  } catch { return []; } }
function saveJournal(e)    { localStorage.setItem(JOURNAL_STORAGE_KEY,    JSON.stringify(e)); }
function loadSaved()       { try { return JSON.parse(localStorage.getItem(SAVED_POSTS_KEY)        || "[]");  } catch { return []; } }
function saveSaved(s)      { localStorage.setItem(SAVED_POSTS_KEY,        JSON.stringify(s)); }

// ─── Rate limiting ──────────────────────────────────────────────────────────────
function checkRateLimit(action, limit, windowMs) {
  try {
    const key = `${RATE_LIMIT_KEY}_${action}`;
    const d = JSON.parse(localStorage.getItem(key) || "{}");
    const now = Date.now();
    const timestamps = (d.timestamps || []).filter(t => now - t < windowMs);
    if (timestamps.length >= limit) return false;
    timestamps.push(now);
    localStorage.setItem(key, JSON.stringify({ timestamps }));
    return true;
  } catch { return true; }
}

// ─── Guest search ───────────────────────────────────────────────────────────────
function getGuestSearchCount() {
  try {
    const d = JSON.parse(localStorage.getItem(GUEST_SEARCH_KEY) || "{}");
    const m = `${new Date().getFullYear()}-${new Date().getMonth()}`;
    return d.month === m ? d.count || 0 : 0;
  } catch { return 0; }
}
function incrementGuestSearch() {
  try {
    const m = `${new Date().getFullYear()}-${new Date().getMonth()}`;
    const d = JSON.parse(localStorage.getItem(GUEST_SEARCH_KEY) || "{}");
    const c = (d.month === m ? d.count || 0 : 0) + 1;
    localStorage.setItem(GUEST_SEARCH_KEY, JSON.stringify({ month:m, count:c }));
    return c;
  } catch { return 1; }
}

// ─── AI helpers ─────────────────────────────────────────────────────────────────
async function fetchFullPicture(query) {
  // Calls the Cypher backend — API key stays on server, never exposed in browser
  const response = await fetch("/api/search", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ query })
  });
  if (!response.ok) throw new Error("Search unavailable");
  const result = await response.json();
  if (result.error) throw new Error(result.error);
  // Normalise single-fact Cypher response into the multi-fact format the UI expects
  return {
    topic: query,
    facts: [{
      fact:        result.fact,
      source_name: result.confidence + " confidence · " + result.category,
      source_url:  "",
      caveat:      result.caveat || ""
    }]
  };
}

async function fetchDailyChallenge() {
  const today = new Date().toISOString().split("T")[0];
  const cached = localStorage.getItem(`vc_challenge_${today}`);
  if (cached) return JSON.parse(cached);
  const prompt = `Generate a single daily challenge question about freedom and world history. Must be factual educational and relate to freedom civil rights revolutions constitutional history or key figures who fought for liberty.
Respond ONLY with valid JSON:
{"question":"the question","options":["A: option","B: option","C: option","D: option"],"correct":"A","explanation":"brief explanation","figure":"key historical figure or event","category":"Civil Rights|Revolution|Constitutional|Independence|Human Rights"}`;
  const response = await fetch("https://api.anthropic.com/v1/messages", {
    method:"POST", headers:{"Content-Type":"application/json"},
    body: JSON.stringify({ model:"claude-sonnet-4-20250514", max_tokens:800, messages:[{role:"user",content:prompt}] })
  });
  const data = await response.json();
  const text = data.content.filter(b=>b.type==="text").map(b=>b.text).join("");
  const clean = text.replace(/```json|```/g,"").trim();
  const s = clean.indexOf("{"), e = clean.lastIndexOf("}");
  if (s===-1||e===-1) throw new Error("Parse error");
  const result = JSON.parse(clean.slice(s,e+1));
  localStorage.setItem(`vc_challenge_${today}`, JSON.stringify(result));
  return result;
}

async function fetchFreedomQuote() {
  const today = new Date().toISOString().split("T")[0];
  const cached = localStorage.getItem(`vc_quote_${today}`);
  if (cached) return JSON.parse(cached);
  const prompt = `Generate a powerful verified historical quote about freedom truth or liberty. Must be from a real documented historical figure with documented contributions to freedom not entertainers or athletes unless their freedom work was separate and documented.
Respond ONLY with valid JSON:
{"quote":"the exact verified quote","author":"Full Name","year":"approximate year","context":"brief context"}`;
  const response = await fetch("https://api.anthropic.com/v1/messages", {
    method:"POST", headers:{"Content-Type":"application/json"},
    body: JSON.stringify({ model:"claude-sonnet-4-20250514", max_tokens:400, messages:[{role:"user",content:prompt}] })
  });
  const data = await response.json();
  const text = data.content.filter(b=>b.type==="text").map(b=>b.text).join("");
  const clean = text.replace(/```json|```/g,"").trim();
  const s = clean.indexOf("{"), e = clean.lastIndexOf("}");
  if (s===-1||e===-1) throw new Error("Parse error");
  const result = JSON.parse(clean.slice(s,e+1));
  localStorage.setItem(`vc_quote_${today}`, JSON.stringify(result));
  return result;
}

// ─── Render @tags ───────────────────────────────────────────────────────────────
function renderBody(body) {
  if (!body) return null;
  return body.split(/(@\w+)/g).map((part,i) =>
    /^@\w+$/.test(part)
      ? <span key={i} style={{color:"var(--gold)",fontWeight:600,cursor:"pointer"}}>{part}</span>
      : part
  );
}

// ─── Profile fonts and layouts ──────────────────────────────────────────────────
const PROFILE_FONTS = ["EB Garamond","Cinzel","DM Mono","Georgia","Garamond","Palatino","Times New Roman","Courier New","Impact","Trebuchet MS","Arial Black","Comic Sans MS","Lucida Console","Tahoma","Verdana","Century Gothic","Copperplate","Didot","Futura","Baskerville"];
const PROFILE_LAYOUTS = ["Classic","Grid","Magazine"];



// ─── Styles ─────────────────────────────────────────────────────────────────────
const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;900&family=EB+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=DM+Mono:wght@300;400;500&display=swap');
  *{margin:0;padding:0;box-sizing:border-box;}
  :root{
    --navy:#0D1B2A;--navy-2:#122236;--navy-3:#1A2F45;--navy-light:#1E3A5F;
    --gold:#C9A84C;--gold-light:#E2C47A;--gold-dim:rgba(201,168,76,0.12);--gold-border:rgba(201,168,76,0.28);
    --white:#FFFFFF;--off-white:#F4EFE6;--muted:#7A8FA6;--muted-light:#9DB0C4;
    --border:rgba(201,168,76,0.22);--border-soft:rgba(255,255,255,0.06);
    --green:#2ECC71;--red:#E74C3C;
  }
  body{background:var(--navy);color:var(--off-white);font-family:'EB Garamond',serif;}
  .app{display:flex;min-height:100vh;}
  .sidebar{width:260px;min-height:100vh;background:var(--navy-2);border-right:1px solid var(--border);display:flex;flex-direction:column;position:fixed;left:0;top:0;bottom:0;z-index:100;overflow-y:auto;}
  .logo{padding:28px 24px 20px;border-bottom:1px solid var(--border);}
  .logo-text{font-family:'Cinzel',serif;font-size:17px;font-weight:900;letter-spacing:0.06em;line-height:1.2;}
  .logo-veritas{color:var(--gold);}
  .logo-cruda{color:var(--white);}
  .logo-tagline{font-family:'DM Mono',monospace;font-size:9px;color:var(--muted);letter-spacing:0.22em;margin-top:5px;text-transform:uppercase;}
  .nav{padding:12px 0;flex:1;}
  .nav-item{display:flex;align-items:center;gap:12px;padding:11px 24px;cursor:pointer;color:var(--muted);font-size:15px;transition:all 0.18s;border-left:3px solid transparent;font-family:'EB Garamond',serif;}
  .nav-item:hover{color:var(--off-white);background:rgba(201,168,76,0.05);}
  .nav-item.active{color:var(--gold);border-left-color:var(--gold);background:var(--gold-dim);font-weight:600;}
  .nav-icon{font-size:17px;width:22px;text-align:center;}
  .nav-badge{background:var(--red);color:white;font-size:9px;font-family:'DM Mono',monospace;padding:1px 5px;border-radius:8px;margin-left:auto;}
  .sidebar-profile{padding:14px 24px;border-top:1px solid var(--border);display:flex;align-items:center;gap:12px;cursor:pointer;transition:background 0.15s;}
  .sidebar-profile:hover{background:rgba(201,168,76,0.05);}
  .sidebar-avatar{width:38px;height:38px;border-radius:50%;border:2px solid var(--gold);background:var(--gold-dim);display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0;overflow:hidden;}
  .sidebar-avatar img{width:100%;height:100%;object-fit:cover;}
  .sidebar-name{font-size:14px;font-weight:600;color:var(--off-white);}
  .sidebar-handle{font-size:11px;color:var(--muted);font-family:'DM Mono',monospace;}
  .sidebar-badge{font-size:10px;color:var(--gold);font-family:'DM Mono',monospace;margin-top:2px;}
  .main{margin-left:260px;flex:1;display:flex;}
  .feed-col{flex:1;max-width:640px;border-right:1px solid var(--border);min-height:100vh;}
  .feed-header{position:sticky;top:0;background:rgba(13,27,42,0.95);backdrop-filter:blur(12px);border-bottom:1px solid var(--border);padding:16px 24px;z-index:10;}
  .feed-header-top{display:flex;align-items:center;justify-content:space-between;}
  .feed-header h2{font-family:'Cinzel',serif;font-size:15px;font-weight:600;letter-spacing:0.12em;color:var(--gold);text-transform:uppercase;}
  .feed-sort-btn{font-family:'DM Mono',monospace;font-size:10px;letter-spacing:0.1em;color:var(--muted);cursor:pointer;background:transparent;border:1px solid var(--border);padding:4px 10px;border-radius:12px;transition:all 0.18s;text-transform:uppercase;}
  .feed-sort-btn.active{color:var(--gold);border-color:var(--gold-border);}
  .feed-tabs{display:flex;margin-top:12px;}
  .feed-tab{flex:1;text-align:center;padding:8px;font-size:11px;font-family:'DM Mono',monospace;letter-spacing:0.08em;color:var(--muted);cursor:pointer;border-bottom:2px solid transparent;transition:all 0.18s;text-transform:uppercase;}
  .feed-tab.active{color:var(--gold);border-bottom-color:var(--gold);}
  .compose{padding:20px 24px;border-bottom:1px solid var(--border-soft);display:flex;gap:14px;}
  .compose-avatar{width:42px;height:42px;border-radius:50%;background:var(--gold-dim);border:2px solid var(--gold);flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:18px;overflow:hidden;}
  .compose-avatar img{width:100%;height:100%;object-fit:cover;}
  .compose-right{flex:1;position:relative;}
  .compose-input{width:100%;background:transparent;border:none;outline:none;color:var(--off-white);font-family:'EB Garamond',serif;font-size:17px;resize:none;min-height:60px;line-height:1.6;}
  .compose-input::placeholder{color:var(--muted);font-style:italic;}
  .compose-actions{display:flex;align-items:center;justify-content:space-between;margin-top:12px;padding-top:12px;border-top:1px solid var(--border-soft);flex-wrap:wrap;gap:8px;}
  .compose-tools{display:flex;gap:16px;align-items:center;}
  .compose-tool{color:var(--gold);cursor:pointer;font-size:16px;opacity:0.7;transition:opacity 0.2s;background:none;border:none;padding:0;}
  .compose-tool:hover{opacity:1;}
  .compose-anon{font-family:'DM Mono',monospace;font-size:10px;color:var(--muted);cursor:pointer;display:flex;align-items:center;gap:4px;letter-spacing:0.08em;}
  .compose-anon input{accent-color:var(--gold);cursor:pointer;}
  .post-btn{background:var(--gold);color:var(--navy);border:none;padding:8px 24px;border-radius:20px;font-family:'Cinzel',serif;font-size:13px;font-weight:700;letter-spacing:0.08em;cursor:pointer;transition:all 0.2s;}
  .post-btn:hover{background:var(--gold-light);transform:translateY(-1px);box-shadow:0 4px 14px rgba(201,168,76,0.3);}
  .tag-suggestions{position:absolute;top:100%;left:0;background:var(--navy-2);border:1px solid var(--border);border-radius:10px;min-width:200px;z-index:50;overflow:hidden;box-shadow:0 8px 24px rgba(0,0,0,0.4);}
  .tag-suggestion-item{padding:10px 16px;cursor:pointer;display:flex;align-items:center;gap:10px;transition:background 0.15s;}
  .tag-suggestion-item:hover{background:var(--gold-dim);}
  .tag-suggestion-handle{font-family:'DM Mono',monospace;font-size:12px;color:var(--gold);}
  .tag-suggestion-name{color:var(--off-white);font-size:13px;}
  .poll-builder{border:1px solid var(--border);border-radius:8px;padding:12px;margin-top:8px;}
  .poll-builder-title{font-family:'DM Mono',monospace;font-size:10px;color:var(--gold);letter-spacing:0.1em;text-transform:uppercase;margin-bottom:8px;}
  .poll-option-input{width:100%;background:var(--navy-3);border:1px solid var(--border);border-radius:6px;padding:7px 10px;color:var(--off-white);font-family:'EB Garamond',serif;font-size:14px;outline:none;margin-bottom:6px;transition:border-color 0.2s;}
  .poll-option-input:focus{border-color:var(--gold);}
  .poll-duration{display:flex;gap:8px;margin-top:6px;}
  .poll-dur-btn{background:transparent;border:1px solid var(--border);color:var(--muted);padding:4px 10px;border-radius:12px;font-family:'DM Mono',monospace;font-size:10px;cursor:pointer;transition:all 0.18s;letter-spacing:0.08em;}
  .poll-dur-btn.active{border-color:var(--gold);color:var(--gold);}
  .post{padding:20px 24px;border-bottom:1px solid var(--border-soft);transition:background 0.15s;}
  .post:hover{background:rgba(201,168,76,0.03);}
  .post.pinned{border-left:3px solid var(--gold);background:rgba(201,168,76,0.04);}
  .content-warning-banner{display:flex;align-items:center;gap:10px;padding:12px 16px;background:rgba(201,168,76,0.08);border-radius:8px;cursor:pointer;font-family:'DM Mono',monospace;font-size:11px;color:var(--muted-light);letter-spacing:0.08em;}
  .post-header{display:flex;gap:12px;align-items:flex-start;}
  .post-avatar{width:42px;height:42px;border-radius:50%;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:18px;border:2px solid transparent;overflow:hidden;}
  .post-avatar img{width:100%;height:100%;object-fit:cover;}
  .post-avatar.org{border-color:var(--gold);}
  .post-avatar.user{border-color:var(--border-soft);background:var(--navy-3);}
  .post-avatar.admin-user{border-color:var(--gold);box-shadow:0 0 10px rgba(201,168,76,0.3);}
  .post-meta{display:flex;align-items:center;gap:8px;flex-wrap:wrap;}
  .post-name{font-weight:600;font-size:15px;color:var(--off-white);}
  .post-org-badge{background:var(--gold-dim);border:1px solid var(--gold-border);color:var(--gold);font-size:10px;font-family:'DM Mono',monospace;padding:1px 6px;border-radius:3px;letter-spacing:0.1em;}
  .post-pin-badge{background:rgba(201,168,76,0.12);border:1px solid var(--gold-border);color:var(--gold);font-size:9px;font-family:'DM Mono',monospace;padding:1px 6px;border-radius:3px;letter-spacing:0.08em;}
  .post-anon-badge{background:rgba(122,143,166,0.15);border:1px solid rgba(122,143,166,0.3);color:var(--muted);font-size:9px;font-family:'DM Mono',monospace;padding:1px 6px;border-radius:3px;}
  .post-handle{color:var(--muted);font-size:12px;font-family:'DM Mono',monospace;}
  .post-time{color:var(--muted-light);font-size:13px;}
  .post-body{margin-top:10px;font-size:16px;line-height:1.65;font-weight:400;padding-left:54px;color:var(--off-white);}
  .post-actions{display:flex;gap:20px;margin-top:14px;padding-left:54px;align-items:center;flex-wrap:wrap;}
  .post-action{display:flex;align-items:center;gap:5px;color:var(--muted);font-size:12px;cursor:pointer;transition:color 0.18s;font-family:'DM Mono',monospace;background:none;border:none;padding:0;}
  .post-action:hover{color:var(--gold);}
  .post-action.liked{color:var(--gold);}
  .post-action.saved{color:var(--gold);}
  .report-btn{margin-left:auto;display:flex;align-items:center;gap:4px;color:var(--muted);font-size:11px;cursor:pointer;font-family:'DM Mono',monospace;transition:color 0.18s;background:none;border:none;padding:0;}
  .report-btn:hover{color:var(--red);}
  .poll-display{margin-top:12px;padding-left:54px;}
  .poll-option-btn{width:100%;background:var(--navy-3);border:1px solid var(--border);border-radius:8px;padding:10px 14px;margin-bottom:6px;cursor:pointer;text-align:left;color:var(--off-white);font-family:'EB Garamond',serif;font-size:15px;transition:all 0.18s;position:relative;overflow:hidden;}
  .poll-option-btn:hover{border-color:var(--gold-border);}
  .poll-option-btn.voted{border-color:var(--gold);}
  .poll-option-fill{position:absolute;left:0;top:0;bottom:0;background:var(--gold-dim);transition:width 0.5s;}
  .poll-option-text{position:relative;z-index:1;}
  .poll-option-pct{position:absolute;right:12px;top:50%;transform:translateY(-50%);font-family:'DM Mono',monospace;font-size:11px;color:var(--gold);z-index:1;}
  .poll-meta{font-family:'DM Mono',monospace;font-size:10px;color:var(--muted);margin-top:4px;letter-spacing:0.08em;}
  .right-col{width:320px;padding:20px;flex-shrink:0;}
  .widget{background:var(--navy-2);border:1px solid var(--border);border-radius:14px;overflow:hidden;margin-bottom:16px;}
  .widget-header{padding:13px 16px;border-bottom:1px solid var(--border);font-family:'Cinzel',serif;font-size:11px;font-weight:700;letter-spacing:0.15em;color:var(--gold);text-transform:uppercase;}
  .trend-item{padding:10px 16px;border-bottom:1px solid var(--border-soft);cursor:pointer;transition:background 0.15s;}
  .trend-item:hover{background:var(--gold-dim);}
  .trend-item:last-child{border-bottom:none;}
  .trend-tag{font-family:'DM Mono',monospace;font-size:13px;color:var(--off-white);}
  .trend-count{font-size:11px;color:var(--muted);margin-top:2px;font-family:'DM Mono',monospace;}
  .suggest-item{padding:10px 16px;display:flex;align-items:center;gap:10px;border-bottom:1px solid var(--border-soft);}
  .suggest-item:last-child{border-bottom:none;}
  .suggest-avatar{width:36px;height:36px;border-radius:50%;background:var(--navy-3);border:1px solid var(--border);display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0;overflow:hidden;}
  .suggest-avatar img{width:100%;height:100%;object-fit:cover;}
  .suggest-name{font-size:14px;font-weight:600;color:var(--off-white);}
  .suggest-handle{font-size:11px;color:var(--muted);font-family:'DM Mono',monospace;}
  .follow-btn{margin-left:auto;background:transparent;border:1px solid var(--gold);color:var(--gold);padding:4px 13px;border-radius:20px;font-size:11px;font-family:'Cinzel',serif;letter-spacing:0.06em;cursor:pointer;transition:all 0.18s;flex-shrink:0;}
  .follow-btn:hover{background:var(--gold);color:var(--navy);font-weight:700;}
  .follow-btn.following{background:var(--gold-dim);color:var(--gold);}
  .auth-screen{min-height:100vh;display:flex;align-items:center;justify-content:center;background:var(--navy);position:relative;overflow:hidden;}
  .auth-bg{position:absolute;inset:0;background:radial-gradient(ellipse at 20% 50%,rgba(201,168,76,0.07) 0%,transparent 60%),radial-gradient(ellipse at 80% 20%,rgba(201,168,76,0.04) 0%,transparent 50%);}
  .auth-card{background:var(--navy-2);border:1px solid var(--border);border-radius:18px;padding:48px 40px;width:460px;position:relative;z-index:1;box-shadow:0 8px 40px rgba(0,0,0,0.4);max-height:90vh;overflow-y:auto;}
  .auth-logo{text-align:center;margin-bottom:24px;}
  .auth-logo-text{font-family:'Cinzel',serif;font-size:28px;font-weight:900;letter-spacing:0.06em;}
  .auth-warning{background:rgba(231,76,60,0.08);border:1px solid rgba(231,76,60,0.25);border-radius:8px;padding:12px 16px;font-family:'DM Mono',monospace;font-size:10px;color:#E88;letter-spacing:0.06em;line-height:1.8;margin-bottom:20px;}
  .auth-warning strong{color:var(--red);display:block;margin-bottom:4px;}
  .auth-tabs{display:flex;border:1px solid var(--border);border-radius:8px;overflow:hidden;margin-bottom:24px;}
  .auth-tab{flex:1;padding:10px;text-align:center;cursor:pointer;font-family:'DM Mono',monospace;font-size:12px;letter-spacing:0.08em;color:var(--muted);transition:all 0.2s;text-transform:uppercase;}
  .auth-tab.active{background:var(--gold);color:var(--navy);font-weight:700;}
  .auth-field{margin-bottom:14px;}
  .auth-label{display:block;font-family:'DM Mono',monospace;font-size:10px;letter-spacing:0.15em;color:var(--muted);margin-bottom:6px;text-transform:uppercase;}
  .auth-input{width:100%;background:var(--navy-3);border:1px solid var(--border);border-radius:8px;padding:12px 14px;color:var(--off-white);font-family:'EB Garamond',serif;font-size:16px;outline:none;transition:border-color 0.2s;}
  .auth-input:focus{border-color:var(--gold);}
  .auth-submit{width:100%;background:var(--gold);color:var(--navy);border:none;padding:14px;border-radius:8px;font-family:'Cinzel',serif;font-size:15px;font-weight:700;letter-spacing:0.1em;cursor:pointer;margin-top:8px;transition:all 0.2s;}
  .auth-submit:hover{background:var(--gold-light);transform:translateY(-1px);box-shadow:0 4px 20px rgba(201,168,76,0.3);}
  .auth-divider{text-align:center;color:var(--muted);font-size:13px;margin:14px 0;font-family:'DM Mono',monospace;letter-spacing:0.1em;}
  .auth-error{color:var(--red);font-family:'DM Mono',monospace;font-size:11px;letter-spacing:0.08em;margin-bottom:8px;}
  .tos-page{min-height:100vh;background:var(--navy);padding:40px;max-width:800px;margin:0 auto;}
  .tos-back{display:inline-flex;align-items:center;gap:8px;color:var(--gold);font-family:'DM Mono',monospace;font-size:13px;cursor:pointer;margin-bottom:32px;letter-spacing:0.08em;background:none;border:none;padding:0;}
  .tos-title{font-family:'Cinzel',serif;font-size:28px;font-weight:900;margin-bottom:8px;color:var(--off-white);}
  .tos-date{font-family:'DM Mono',monospace;font-size:12px;color:var(--muted);margin-bottom:32px;letter-spacing:0.1em;}
  .tos-body{font-size:15px;line-height:1.8;color:var(--muted-light);white-space:pre-wrap;}
  .scrollable{overflow-y:auto;max-height:calc(100vh - 130px);}
  .modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.75);z-index:200;display:flex;align-items:center;justify-content:center;padding:20px;}
  .modal{background:var(--navy-2);border:1px solid var(--border);border-radius:16px;padding:32px;width:100%;max-width:520px;box-shadow:0 16px 48px rgba(0,0,0,0.5);max-height:90vh;overflow-y:auto;}
  .modal-title{font-family:'Cinzel',serif;font-size:18px;font-weight:900;color:var(--off-white);margin-bottom:6px;}
  .modal-sub{font-family:'DM Mono',monospace;font-size:10px;color:var(--muted);letter-spacing:0.15em;text-transform:uppercase;margin-bottom:20px;}
  .modal-field{margin-bottom:14px;}
  .modal-label{display:block;font-family:'DM Mono',monospace;font-size:10px;letter-spacing:0.15em;color:var(--muted);margin-bottom:6px;text-transform:uppercase;}
  .modal-input{width:100%;background:var(--navy-3);border:1px solid var(--border);border-radius:8px;padding:11px 14px;color:var(--off-white);font-family:'EB Garamond',serif;font-size:15px;outline:none;transition:border-color 0.2s;}
  .modal-input:focus{border-color:var(--gold);}
  .modal-textarea{width:100%;background:var(--navy-3);border:1px solid var(--border);border-radius:8px;padding:11px 14px;color:var(--off-white);font-family:'EB Garamond',serif;font-size:15px;outline:none;transition:border-color 0.2s;resize:vertical;min-height:90px;}
  .modal-textarea:focus{border-color:var(--gold);}
  .modal-actions{display:flex;gap:10px;margin-top:20px;}
  .modal-submit{flex:1;background:var(--gold);color:var(--navy);border:none;padding:12px;border-radius:8px;font-family:'Cinzel',serif;font-size:13px;font-weight:700;letter-spacing:0.08em;cursor:pointer;transition:all 0.2s;}
  .modal-submit:hover{background:var(--gold-light);}
  .modal-cancel{background:transparent;color:var(--muted);border:1px solid var(--border);padding:12px 20px;border-radius:8px;font-family:'DM Mono',monospace;font-size:11px;cursor:pointer;transition:all 0.2s;}
  .modal-cancel:hover{border-color:var(--muted-light);color:var(--off-white);}
  .modal-warning{background:rgba(231,76,60,0.1);border:1px solid rgba(231,76,60,0.3);border-radius:8px;padding:12px 14px;font-family:'DM Mono',monospace;font-size:10px;color:var(--muted-light);letter-spacing:0.08em;line-height:1.8;margin-bottom:16px;}
  .modal-warning span{color:var(--red);}
  .modal-error{font-family:'DM Mono',monospace;font-size:11px;color:var(--red);margin-top:8px;letter-spacing:0.08em;}
  .modal-success{font-family:'DM Mono',monospace;font-size:11px;color:var(--green);margin-top:8px;letter-spacing:0.08em;}
  .journal-page{flex:1;max-width:740px;border-right:1px solid var(--border);min-height:100vh;display:flex;flex-direction:column;}
  .journal-header{position:sticky;top:0;background:rgba(13,27,42,0.96);backdrop-filter:blur(12px);border-bottom:1px solid var(--border);padding:20px 28px;z-index:10;}
  .journal-header-top{display:flex;align-items:center;justify-content:space-between;}
  .journal-title-text{font-family:'Cinzel',serif;font-size:18px;font-weight:900;letter-spacing:0.1em;color:var(--gold);}
  .journal-subtitle{font-family:'DM Mono',monospace;font-size:10px;color:var(--muted);letter-spacing:0.2em;margin-top:4px;}
  .journal-lock-badge{display:flex;align-items:center;gap:6px;background:rgba(46,204,113,0.1);border:1px solid rgba(46,204,113,0.3);border-radius:20px;padding:4px 12px;font-family:'DM Mono',monospace;font-size:10px;color:var(--green);letter-spacing:0.1em;}
  .journal-unlock-screen{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:40px;gap:20px;}
  .journal-unlock-icon{font-size:48px;}
  .journal-unlock-title{font-family:'Cinzel',serif;font-size:22px;font-weight:900;color:var(--off-white);text-align:center;}
  .journal-unlock-sub{font-family:'DM Mono',monospace;font-size:11px;color:var(--muted);letter-spacing:0.12em;text-align:center;line-height:1.8;max-width:380px;}
  .journal-unlock-warning{background:var(--gold-dim);border:1px solid var(--border);border-radius:10px;padding:14px 18px;font-family:'DM Mono',monospace;font-size:10px;color:var(--muted-light);letter-spacing:0.08em;line-height:1.8;max-width:400px;text-align:center;}
  .journal-unlock-warning span{color:var(--gold);}
  .journal-key-input{width:100%;max-width:380px;background:var(--navy-3);border:1px solid var(--border);border-radius:10px;padding:14px 18px;color:var(--off-white);font-family:'DM Mono',monospace;font-size:14px;outline:none;transition:border-color 0.2s;letter-spacing:0.05em;text-align:center;}
  .journal-key-input:focus{border-color:var(--gold);}
  .journal-unlock-btn{background:var(--gold);color:var(--navy);border:none;padding:12px 40px;border-radius:8px;font-family:'Cinzel',serif;font-size:14px;font-weight:700;letter-spacing:0.12em;cursor:pointer;transition:all 0.2s;}
  .journal-unlock-btn:hover{background:var(--gold-light);transform:translateY(-1px);}
  .journal-unlock-btn:disabled{opacity:0.5;cursor:not-allowed;transform:none;}
  .journal-error{font-family:'DM Mono',monospace;font-size:11px;color:var(--red);letter-spacing:0.1em;}
  .journal-body{flex:1;display:flex;flex-direction:column;overflow:hidden;}
  .journal-list{flex:1;overflow-y:auto;}
  .journal-toolbar{display:flex;align-items:center;justify-content:space-between;padding:12px 28px;border-bottom:1px solid var(--border-soft);}
  .journal-download-btn{display:flex;align-items:center;gap:6px;background:var(--gold-dim);border:1px solid var(--gold-border);color:var(--gold);padding:7px 16px;border-radius:8px;font-family:'DM Mono',monospace;font-size:11px;cursor:pointer;letter-spacing:0.08em;transition:all 0.2s;}
  .journal-download-btn:hover{background:var(--gold);color:var(--navy);}
  .journal-empty{padding:60px 28px;text-align:center;color:var(--muted);font-style:italic;font-size:16px;line-height:1.8;}
  .journal-entry-card{padding:24px 28px;border-bottom:1px solid var(--border-soft);cursor:pointer;transition:background 0.15s;}
  .journal-entry-card:hover{background:var(--gold-dim);}
  .journal-entry-date{font-family:'DM Mono',monospace;font-size:10px;color:var(--gold);letter-spacing:0.15em;margin-bottom:6px;}
  .journal-entry-title{font-family:'Cinzel',serif;font-size:16px;font-weight:600;color:var(--off-white);margin-bottom:6px;}
  .journal-entry-preview{font-size:14px;color:var(--muted);line-height:1.6;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
  .journal-new-btn{margin:20px 28px;background:transparent;border:1px dashed var(--gold-border);color:var(--gold);padding:14px;border-radius:10px;font-family:'Cinzel',serif;font-size:13px;letter-spacing:0.1em;cursor:pointer;transition:all 0.2s;display:flex;align-items:center;justify-content:center;gap:8px;}
  .journal-new-btn:hover{border-color:var(--gold);background:var(--gold-dim);}
  .journal-editor{flex:1;display:flex;flex-direction:column;padding:24px 28px;gap:16px;overflow-y:auto;}
  .journal-editor-back{display:inline-flex;align-items:center;gap:8px;color:var(--muted);font-family:'DM Mono',monospace;font-size:11px;cursor:pointer;letter-spacing:0.08em;transition:color 0.2s;background:none;border:none;padding:0;}
  .journal-editor-back:hover{color:var(--gold);}
  .journal-editor-title{width:100%;background:transparent;border:none;outline:none;font-family:'Cinzel',serif;font-size:22px;font-weight:900;color:var(--off-white);border-bottom:1px solid var(--border);padding-bottom:12px;}
  .journal-editor-title::placeholder{color:var(--navy-light);}
  .journal-editor-body{flex:1;width:100%;background:transparent;border:none;outline:none;font-family:'EB Garamond',serif;font-size:17px;color:var(--off-white);resize:none;line-height:1.8;min-height:320px;}
  .journal-editor-body::placeholder{color:var(--muted);font-style:italic;}
  .journal-editor-actions{display:flex;gap:10px;align-items:center;padding-top:12px;border-top:1px solid var(--border);}
  .journal-save-btn{background:var(--gold);color:var(--navy);border:none;padding:10px 28px;border-radius:8px;font-family:'Cinzel',serif;font-size:13px;font-weight:700;letter-spacing:0.08em;cursor:pointer;transition:all 0.2s;}
  .journal-save-btn:hover{background:var(--gold-light);transform:translateY(-1px);}
  .journal-save-btn:disabled{opacity:0.5;cursor:not-allowed;transform:none;}
  .journal-delete-btn{background:transparent;color:var(--red);border:1px solid var(--red);padding:10px 20px;border-radius:8px;font-family:'DM Mono',monospace;font-size:11px;cursor:pointer;transition:all 0.2s;}
  .journal-delete-btn:hover{background:var(--red);color:white;}
  .journal-saving{font-family:'DM Mono',monospace;font-size:10px;color:var(--muted);letter-spacing:0.1em;margin-left:auto;}
  .journal-saving.done{color:var(--green);}
  .fp-page{flex:1;max-width:740px;border-right:1px solid var(--border);min-height:100vh;display:flex;flex-direction:column;}
  .fp-header{position:sticky;top:0;background:rgba(13,27,42,0.96);backdrop-filter:blur(12px);border-bottom:1px solid var(--border);padding:20px 28px;z-index:10;}
  .fp-title{font-family:'Cinzel',serif;font-size:18px;font-weight:900;letter-spacing:0.1em;color:var(--gold);}
  .fp-subtitle{font-family:'DM Mono',monospace;font-size:10px;color:var(--muted);letter-spacing:0.2em;margin-top:4px;text-transform:uppercase;}
  .fp-body{flex:1;display:flex;flex-direction:column;padding:28px;gap:20px;overflow-y:auto;}
  .fp-search-box{display:flex;gap:10px;}
  .fp-input{flex:1;background:var(--navy-3);border:1px solid var(--border);border-radius:10px;padding:14px 18px;color:var(--off-white);font-family:'EB Garamond',serif;font-size:17px;outline:none;transition:border-color 0.2s;}
  .fp-input:focus{border-color:var(--gold);}
  .fp-input::placeholder{color:var(--muted);font-style:italic;}
  .fp-search-btn{background:var(--gold);color:var(--navy);border:none;padding:14px 28px;border-radius:10px;font-family:'Cinzel',serif;font-size:13px;font-weight:700;letter-spacing:0.08em;cursor:pointer;transition:all 0.2s;white-space:nowrap;}
  .fp-search-btn:hover{background:var(--gold-light);transform:translateY(-1px);}
  .fp-search-btn:disabled{opacity:0.5;cursor:not-allowed;transform:none;}
  .fp-loading{display:flex;flex-direction:column;align-items:center;gap:12px;padding:40px;color:var(--muted);font-family:'DM Mono',monospace;font-size:11px;letter-spacing:0.15em;text-align:center;}
  .fp-spinner{width:32px;height:32px;border:2px solid var(--border);border-top-color:var(--gold);border-radius:50%;animation:spin 0.8s linear infinite;}
  @keyframes spin{to{transform:rotate(360deg);}}
  .fp-results{display:flex;flex-direction:column;gap:16px;}
  .fp-topic{font-family:'Cinzel',serif;font-size:20px;font-weight:900;color:var(--off-white);padding-bottom:12px;border-bottom:1px solid var(--border);}
  .fp-fact{background:var(--navy-2);border:1px solid var(--border);border-radius:12px;padding:18px 20px;display:flex;flex-direction:column;gap:10px;}
  .fp-fact-num{font-family:'DM Mono',monospace;font-size:10px;color:var(--gold);letter-spacing:0.15em;}
  .fp-fact-text{font-size:16px;line-height:1.7;color:var(--off-white);}
  .fp-fact-source{display:flex;align-items:center;gap:8px;}
  .fp-fact-source-label{font-family:'DM Mono',monospace;font-size:10px;color:var(--muted);letter-spacing:0.1em;text-transform:uppercase;}
  .fp-fact-source a{font-family:'DM Mono',monospace;font-size:11px;color:var(--gold);text-decoration:none;word-break:break-all;}
  .fp-fact-source a:hover{color:var(--gold-light);text-decoration:underline;}
  .fp-error{background:rgba(231,76,60,0.1);border:1px solid var(--red);border-radius:10px;padding:16px 20px;font-family:'DM Mono',monospace;font-size:12px;color:var(--red);letter-spacing:0.08em;text-align:center;}
  .fp-empty{padding:60px 28px;text-align:center;color:var(--muted);font-size:15px;line-height:1.8;}
  .fp-disclaimer{font-family:'DM Mono',monospace;font-size:10px;color:var(--muted);letter-spacing:0.08em;line-height:1.7;padding:16px 20px;background:var(--navy-2);border:1px solid var(--border-soft);border-radius:10px;}
  .fp-limit-notice{background:var(--gold-dim);border:1px solid var(--border);border-radius:10px;padding:14px 18px;font-family:'DM Mono',monospace;font-size:11px;color:var(--muted-light);letter-spacing:0.08em;line-height:1.8;text-align:center;}
  .fp-guest-counter{font-family:'DM Mono',monospace;font-size:11px;color:var(--muted);letter-spacing:0.1em;text-align:right;}
  .fp-guest-counter span{color:var(--gold);}
  .challenge-page{flex:1;max-width:740px;border-right:1px solid var(--border);min-height:100vh;display:flex;flex-direction:column;}
  .challenge-header{position:sticky;top:0;background:rgba(13,27,42,0.96);backdrop-filter:blur(12px);border-bottom:1px solid var(--border);padding:20px 28px;z-index:10;}
  .challenge-title-text{font-family:'Cinzel',serif;font-size:18px;font-weight:900;letter-spacing:0.1em;color:var(--gold);}
  .challenge-subtitle{font-family:'DM Mono',monospace;font-size:10px;color:var(--muted);letter-spacing:0.2em;margin-top:4px;text-transform:uppercase;}
  .challenge-body{flex:1;padding:28px;overflow-y:auto;display:flex;flex-direction:column;gap:20px;}
  .challenge-card{background:var(--navy-2);border:1px solid var(--border);border-radius:16px;padding:28px;}
  .challenge-category{font-family:'DM Mono',monospace;font-size:10px;color:var(--gold);letter-spacing:0.2em;text-transform:uppercase;margin-bottom:12px;}
  .challenge-question{font-family:'EB Garamond',serif;font-size:20px;line-height:1.6;color:var(--off-white);margin-bottom:24px;}
  .challenge-options{display:flex;flex-direction:column;gap:10px;}
  .challenge-option{background:var(--navy-3);border:1px solid var(--border);border-radius:10px;padding:14px 18px;cursor:pointer;font-family:'EB Garamond',serif;font-size:16px;color:var(--off-white);transition:all 0.18s;text-align:left;}
  .challenge-option:hover:not(:disabled){border-color:var(--gold-border);background:var(--gold-dim);}
  .challenge-option.correct{border-color:var(--green);background:rgba(46,204,113,0.1);color:var(--green);}
  .challenge-option.wrong{border-color:var(--red);background:rgba(231,76,60,0.1);color:var(--red);}
  .challenge-option:disabled{cursor:not-allowed;}
  .challenge-explanation{background:var(--navy-3);border:1px solid var(--border);border-radius:10px;padding:16px 20px;font-size:15px;color:var(--muted-light);line-height:1.7;}
  .challenge-figure{font-family:'DM Mono',monospace;font-size:11px;color:var(--gold);letter-spacing:0.1em;margin-top:8px;}
  .challenge-example-section{margin-top:16px;}
  .challenge-example-label{font-family:'DM Mono',monospace;font-size:11px;color:var(--muted);letter-spacing:0.15em;text-transform:uppercase;margin-bottom:8px;}
  .challenge-example-input{width:100%;background:var(--navy-3);border:1px solid var(--border);border-radius:8px;padding:11px 14px;color:var(--off-white);font-family:'EB Garamond',serif;font-size:15px;outline:none;resize:vertical;min-height:80px;transition:border-color 0.2s;}
  .challenge-example-input:focus{border-color:var(--gold);}
  .challenge-submit-example{margin-top:8px;background:transparent;border:1px solid var(--gold);color:var(--gold);padding:8px 20px;border-radius:8px;font-family:'DM Mono',monospace;font-size:11px;cursor:pointer;transition:all 0.18s;letter-spacing:0.08em;}
  .challenge-submit-example:hover{background:var(--gold);color:var(--navy);}
  .challenge-score-card{background:var(--navy-2);border:1px solid var(--border);border-radius:12px;padding:20px;display:flex;align-items:center;justify-content:space-between;}
  .challenge-score-label{font-family:'DM Mono',monospace;font-size:11px;color:var(--muted);letter-spacing:0.15em;text-transform:uppercase;}
  .challenge-score-val{font-family:'Cinzel',serif;font-size:28px;font-weight:900;color:var(--gold);}
  .onboarding-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.85);z-index:300;display:flex;align-items:center;justify-content:center;padding:20px;}
  .onboarding-card{background:var(--navy-2);border:1px solid var(--border);border-radius:20px;padding:40px;width:100%;max-width:560px;box-shadow:0 20px 60px rgba(0,0,0,0.6);}
  .onboarding-step{font-family:'DM Mono',monospace;font-size:10px;color:var(--gold);letter-spacing:0.2em;text-transform:uppercase;margin-bottom:8px;}
  .onboarding-title{font-family:'Cinzel',serif;font-size:24px;font-weight:900;color:var(--off-white);margin-bottom:12px;}
  .onboarding-body{font-size:16px;color:var(--muted-light);line-height:1.8;margin-bottom:28px;}
  .onboarding-nav{display:flex;justify-content:space-between;align-items:center;}
  .onboarding-dots{display:flex;gap:6px;}
  .onboarding-dot{width:8px;height:8px;border-radius:50%;background:var(--border);transition:background 0.2s;}
  .onboarding-dot.active{background:var(--gold);}
  .onboarding-next{background:var(--gold);color:var(--navy);border:none;padding:10px 28px;border-radius:8px;font-family:'Cinzel',serif;font-size:13px;font-weight:700;letter-spacing:0.08em;cursor:pointer;transition:all 0.2s;}
  .onboarding-next:hover{background:var(--gold-light);}
  .onboarding-skip{background:transparent;border:none;color:var(--muted);font-family:'DM Mono',monospace;font-size:11px;cursor:pointer;letter-spacing:0.1em;padding:0;transition:color 0.2s;}
  .onboarding-skip:hover{color:var(--off-white);}
  .profile-page{flex:1;display:flex;}
  .profile-main{flex:1;overflow-y:auto;}
  .profile-banner{height:200px;background:linear-gradient(135deg,var(--navy-3) 0%,var(--navy-light) 50%,var(--navy-2) 100%);position:relative;overflow:hidden;}
  .profile-banner img{width:100%;height:100%;object-fit:cover;position:absolute;inset:0;}
  .profile-banner-edit{position:absolute;bottom:12px;right:12px;background:rgba(0,0,0,0.6);border:1px solid rgba(255,255,255,0.3);color:white;padding:6px 14px;border-radius:20px;font-size:11px;cursor:pointer;font-family:'DM Mono',monospace;letter-spacing:0.08em;transition:all 0.2s;}
  .profile-info-bar{padding:0 24px 20px;border-bottom:1px solid var(--border);position:relative;}
  .profile-avatar-wrap{margin-top:-48px;margin-bottom:12px;}
  .profile-avatar-lg{width:96px;height:96px;border-radius:50%;border:4px solid var(--navy);background:var(--navy-3);display:flex;align-items:center;justify-content:center;font-size:40px;overflow:hidden;cursor:pointer;}
  .profile-avatar-lg img{width:100%;height:100%;object-fit:cover;}
  .profile-name{font-family:'Cinzel',serif;font-size:22px;font-weight:900;color:var(--off-white);}
  .profile-handle{font-family:'DM Mono',monospace;font-size:13px;color:var(--muted);margin-top:2px;}
  .profile-badge-display{display:inline-flex;align-items:center;gap:6px;margin-top:6px;font-family:'DM Mono',monospace;font-size:11px;color:var(--gold);letter-spacing:0.1em;}
  .profile-bio{font-size:15px;color:var(--muted-light);margin-top:10px;line-height:1.5;font-style:italic;cursor:text;}
  .profile-bio-edit{font-size:15px;color:var(--off-white);margin-top:10px;line-height:1.5;background:transparent;border:none;outline:none;width:100%;font-family:'EB Garamond',serif;resize:none;}
  .profile-stats{display:flex;gap:24px;margin-top:14px;}
  .stat{cursor:pointer;}
  .stat-num{font-weight:600;font-size:16px;color:var(--off-white);}
  .stat-label{font-size:13px;color:var(--muted);}
  .profile-website{font-family:'DM Mono',monospace;font-size:11px;color:var(--gold);margin-top:8px;text-decoration:none;display:inline-flex;align-items:center;gap:4px;letter-spacing:0.05em;}
  .profile-website:hover{color:var(--gold-light);}
  .customize-panel{margin:20px 24px;background:var(--navy-2);border:1px solid var(--border);border-radius:12px;overflow:hidden;}
  .customize-header{padding:14px 16px;background:var(--gold-dim);border-bottom:1px solid var(--border);font-family:'Cinzel',serif;font-size:13px;letter-spacing:0.1em;color:var(--gold);display:flex;justify-content:space-between;align-items:center;}
  .customize-body{padding:16px;}
  .customize-row{display:flex;flex-direction:column;gap:8px;margin-bottom:16px;}
  .customize-label{font-family:'DM Mono',monospace;font-size:11px;letter-spacing:0.15em;color:var(--muted);text-transform:uppercase;}
  .font-opt{padding:6px 12px;border:1px solid var(--border-soft);border-radius:6px;font-size:13px;cursor:pointer;color:var(--muted-light);transition:all 0.2s;}
  .font-opt:hover,.font-opt.selected{border-color:var(--gold);color:var(--gold);background:var(--gold-dim);}
  .layout-options{display:flex;gap:8px;}
  .layout-opt{flex:1;padding:8px;border:1px solid var(--border-soft);border-radius:6px;text-align:center;cursor:pointer;font-size:12px;color:var(--muted);font-family:'DM Mono',monospace;transition:all 0.2s;}
  .layout-opt:hover,.layout-opt.selected{border-color:var(--gold);color:var(--gold);background:var(--gold-dim);}
  .css-editor{width:100%;background:var(--navy-3);border:1px solid var(--border);border-radius:8px;padding:12px;color:var(--off-white);font-family:'DM Mono',monospace;font-size:12px;outline:none;resize:vertical;min-height:120px;line-height:1.6;transition:border-color 0.2s;}
  .css-editor:focus{border-color:var(--gold);}
  .admin-panel{width:300px;background:var(--navy-2);border-left:1px solid var(--border);height:100vh;position:sticky;top:0;overflow-y:auto;flex-shrink:0;}
  .admin-panel-header{padding:20px 16px;border-bottom:1px solid var(--border);}
  .admin-panel-title{font-family:'DM Mono',monospace;font-size:11px;letter-spacing:0.2em;color:var(--gold);text-transform:uppercase;}
  .admin-stat-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;padding:16px;}
  .admin-stat-box{background:var(--navy-3);border:1px solid var(--border);border-radius:8px;padding:12px;}
  .admin-stat-box-num{font-family:'Cinzel',serif;font-size:24px;font-weight:900;color:var(--off-white);}
  .admin-stat-box-label{font-family:'DM Mono',monospace;font-size:10px;color:var(--muted);letter-spacing:0.1em;margin-top:2px;text-transform:uppercase;}
  .admin-section-title{font-family:'DM Mono',monospace;font-size:10px;letter-spacing:0.2em;color:var(--muted);padding:12px 16px 8px;border-top:1px solid var(--border);text-transform:uppercase;}
  .admin-user-row{display:flex;align-items:center;gap:8px;padding:8px 16px;border-bottom:1px solid var(--border-soft);}
  .admin-user-row:hover{background:rgba(201,168,76,0.03);}
  .admin-mini-avatar{width:28px;height:28px;border-radius:50%;background:var(--navy-3);border:1px solid var(--border);display:flex;align-items:center;justify-content:center;font-size:12px;flex-shrink:0;overflow:hidden;}
  .admin-mini-avatar img{width:100%;height:100%;object-fit:cover;}
  .admin-mini-name{font-size:12px;font-weight:600;flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--off-white);}
  .admin-mini-handle{font-size:10px;color:var(--muted);font-family:'DM Mono',monospace;}
  .admin-mini-badge{font-size:9px;font-family:'DM Mono',monospace;padding:1px 5px;border-radius:3px;}
  .admin-mini-badge.org{background:var(--gold-dim);border:1px solid var(--gold-border);color:var(--gold);}
  .admin-mini-badge.banned{background:rgba(231,76,60,0.15);border:1px solid var(--red);color:var(--red);}
  .admin-mini-badge.restricted{background:rgba(255,165,0,0.15);border:1px solid orange;color:orange;}
  .mini-ban-btn{font-size:10px;font-family:'DM Mono',monospace;padding:2px 8px;border-radius:4px;cursor:pointer;border:1px solid var(--red);background:transparent;color:var(--red);transition:all 0.15s;flex-shrink:0;}
  .mini-ban-btn:hover{background:var(--red);color:white;}
  .mini-unban-btn{font-size:10px;font-family:'DM Mono',monospace;padding:2px 8px;border-radius:4px;cursor:pointer;border:1px solid var(--green);background:transparent;color:var(--green);transition:all 0.15s;flex-shrink:0;}
  .mini-unban-btn:hover{background:var(--green);color:white;}
  .admin-post-row{padding:8px 16px;border-bottom:1px solid var(--border-soft);}
  .admin-post-row:hover{background:rgba(201,168,76,0.03);}
  .admin-post-meta{display:flex;align-items:center;justify-content:space-between;margin-bottom:4px;}
  .admin-post-user{font-size:10px;color:var(--gold);font-family:'DM Mono',monospace;}
  .admin-post-time{font-size:10px;color:var(--muted);font-family:'DM Mono',monospace;}
  .admin-post-text{font-size:12px;color:var(--muted-light);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-bottom:6px;}
  .mini-delete-btn{font-size:10px;font-family:'DM Mono',monospace;padding:2px 8px;border-radius:4px;cursor:pointer;border:1px solid var(--red);background:transparent;color:var(--red);transition:all 0.15s;}
  .mini-delete-btn:hover{background:var(--red);color:white;}
  .report-queue-item{padding:12px 16px;border-bottom:1px solid var(--border-soft);}
  .report-queue-meta{display:flex;justify-content:space-between;margin-bottom:6px;}
  .report-queue-from{font-size:10px;color:var(--gold);font-family:'DM Mono',monospace;}
  .report-queue-against{font-size:10px;color:var(--red);font-family:'DM Mono',monospace;}
  .report-queue-desc{font-size:12px;color:var(--muted-light);margin-bottom:4px;line-height:1.5;}
  .report-queue-link{font-size:10px;color:var(--gold);font-family:'DM Mono',monospace;word-break:break-all;margin-bottom:8px;}
  .report-queue-actions{display:flex;gap:8px;}
  .report-approve-btn{font-size:10px;font-family:'DM Mono',monospace;padding:3px 10px;border-radius:4px;cursor:pointer;border:1px solid var(--green);background:transparent;color:var(--green);transition:all 0.15s;}
  .report-approve-btn:hover{background:var(--green);color:white;}
  .report-dismiss-btn{font-size:10px;font-family:'DM Mono',monospace;padding:3px 10px;border-radius:4px;cursor:pointer;border:1px solid var(--muted);background:transparent;color:var(--muted);transition:all 0.15s;}
  .report-dismiss-btn:hover{background:var(--muted);color:white;}
  .saved-page{flex:1;max-width:640px;border-right:1px solid var(--border);min-height:100vh;display:flex;flex-direction:column;}
  .saved-header{position:sticky;top:0;background:rgba(13,27,42,0.95);backdrop-filter:blur(12px);border-bottom:1px solid var(--border);padding:20px 24px;z-index:10;}
  .saved-title{font-family:'Cinzel',serif;font-size:15px;font-weight:600;letter-spacing:0.12em;color:var(--gold);text-transform:uppercase;}
  .quote-widget{background:var(--navy-2);border:1px solid var(--border);border-radius:14px;overflow:hidden;margin-bottom:16px;}
  .quote-body{padding:16px;font-size:15px;color:var(--off-white);line-height:1.7;font-style:italic;}
  .quote-author{padding:0 16px 14px;font-family:'DM Mono',monospace;font-size:10px;color:var(--gold);letter-spacing:0.12em;}
  .leaderboard-item{padding:10px 16px;border-bottom:1px solid var(--border-soft);display:flex;align-items:center;gap:10px;}
  .leaderboard-item:last-child{border-bottom:none;}
  @media(max-width:1200px){.admin-panel{display:none;}}
  @media(max-width:1000px){.right-col{display:none;}}
  @media(max-width:700px){
    .sidebar{width:60px;}
    .logo-text,.logo-tagline,.sidebar-name,.sidebar-handle,.sidebar-badge,.nav-item span{display:none;}
    .main{margin-left:60px;}
    .nav-item{justify-content:center;padding:14px;}
    .auth-card{width:90vw;padding:28px 20px;}
  }
`;



// ─── PostCard ────────────────────────────────────────────────────────────────
function PostCard({ post, onLike, onReport, onSave, onVotePoll, savedPosts, currentUser }) {
  const [warningDismissed, setWarningDismissed] = React.useState(false);
  const isSaved = savedPosts?.find(s => s.id === post.id);
  const totalPollVotes = post.poll ? post.poll.options.reduce((s, o) => s + o.votes, 0) : 0;
  const hasVoted = post.poll?.votedBy?.includes(currentUser?.handle);

  if (post.contentWarning && !warningDismissed) return (
    <div className="post" style={{ cursor: "pointer" }} onClick={() => setWarningDismissed(true)}>
      <div className="content-warning-banner">⚠ {post.contentWarning} — tap to reveal</div>
    </div>
  );

  return (
    <div className={`post${post.pinned ? " pinned" : ""}`}>
      <div className="post-header">
        <div className={`post-avatar${post.isAdmin ? " admin-user" : post.isOrg ? " org" : " user"}`}>
          {post.photo ? <img src={post.photo} alt="" /> : post.avatar}
        </div>
        <div style={{ flex: 1 }}>
          <div className="post-meta">
            <span className="post-name">{post.name}</span>
            {post.isOrg && <span className="post-org-badge">ORG</span>}
            {post.pinned && <span className="post-pin-badge">📌 FOUNDER</span>}
            {post.anonymous && <span className="post-anon-badge">ANON</span>}
            <span className="post-handle">{post.handle}</span>
            <span className="post-time">· {post.time}</span>
          </div>
        </div>
      </div>
      <div className="post-body">{renderBody(post.body)}</div>
      {post.poll && (
        <div className="poll-display">
          {post.poll.options.map((opt, i) => {
            const pct = totalPollVotes > 0 ? Math.round((opt.votes / totalPollVotes) * 100) : 0;
            return (
              <button key={i} className={`poll-option-btn${hasVoted ? " voted" : ""}`}
                onClick={() => !hasVoted && onVotePoll && onVotePoll(post.id, i)} disabled={hasVoted}>
                {hasVoted && <div className="poll-option-fill" style={{ width: `${pct}%` }} />}
                <span className="poll-option-text">{opt.text}</span>
                {hasVoted && <span className="poll-option-pct">{pct}%</span>}
              </button>
            );
          })}
          <div className="poll-meta">{totalPollVotes} vote{totalPollVotes !== 1 ? "s" : ""} · {post.poll.duration}</div>
        </div>
      )}
      <div className="post-actions">
        <button className="post-action">💬 {post.comments}</button>
        <button className="post-action">🔁 {post.reposts}</button>
        <button className={`post-action${post.liked ? " liked" : ""}`} onClick={() => onLike(post.id)}>
          {post.liked ? "❤️" : "🤍"} {post.likes}
        </button>
        <button className={`post-action${isSaved ? " saved" : ""}`} onClick={() => onSave && onSave(post)} title="Save">
          {isSaved ? "🔖" : "🏷️"}
        </button>
        <button className="post-action">↗ Share</button>
        {!post.pinned && <button className="report-btn" onClick={() => onReport(post)}>⚑ Report</button>}
      </div>
    </div>
  );
}



// ─── Main App ────────────────────────────────────────────────────────────────
export default function App() {
  const [page, setPage] = React.useState("landing");
  const [prevPage, setPrevPage]     = React.useState("auth");
  const [authTab, setAuthTab]       = React.useState("login");
  const [isAdmin, setIsAdmin]       = React.useState(false);
  const [isMember, setIsMember]     = React.useState(false);
  const [loginEmail, setLoginEmail] = React.useState("");
  const [loginPw, setLoginPw]       = React.useState("");
  const [signupName, setSignupName] = React.useState("");
  const [authError, setAuthError]   = React.useState("");
  const [tosChecked, setTosChecked] = React.useState(false);
  const [tosError, setTosError]     = React.useState(false);

  // Feed
  const [feedPosts, setFeedPosts]   = React.useState([WELCOME_POST]);
  const [adminPosts, setAdminPosts] = React.useState([]);
  const [feedTab, setFeedTab]       = React.useState("For You");
  const [feedSort, setFeedSort]     = React.useState("latest");
  const [composeText, setComposeText] = React.useState("");
  const [composeAnon, setComposeAnon] = React.useState(false);
  const [showPollBuilder, setShowPollBuilder] = React.useState(false);
  const [pollOptions, setPollOptions] = React.useState(["", "", "", ""]);
  const [pollDuration, setPollDuration] = React.useState("24h");
  const [tagSuggestions, setTagSuggestions] = React.useState([]);
  const [anonCount, setAnonCount]   = React.useState(0);
  const [users, setUsers]           = React.useState([]);
  const [followedUsers, setFollowedUsers] = React.useState([]);
  const [savedPosts, setSavedPosts] = React.useState(() => loadSaved());
  const [navActive, setNavActive]   = React.useState("feed");
  const composeRef = React.useRef(null);

  // Profile
  const [profilePhoto, setProfilePhoto]     = React.useState("");
  const [profileBanner, setProfileBanner]   = React.useState("");
  const [profileBio, setProfileBio]         = React.useState("The raw truth, unfiltered.");
  const [profileWebsite, setProfileWebsite] = React.useState("");
  const [profileEditingBio, setProfileEditingBio] = React.useState(false);
  const [profileColor, setProfileColor]     = React.useState("#C9A84C");
  const [profileFont, setProfileFont]       = React.useState("EB Garamond");
  const [profileLayout, setProfileLayout]   = React.useState("Classic");
  const [profileBgUrl, setProfileBgUrl]     = React.useState("");
  const [profileBgInput, setProfileBgInput] = React.useState("");
  const [profileMusicUrl, setProfileMusicUrl]   = React.useState("");
  const [profileMusicInput, setProfileMusicInput] = React.useState("");
  const [profileCss, setProfileCss]         = React.useState("");
  const [showCustomize, setShowCustomize]   = React.useState(false);

  // Journal
  const [journalUnlocked, setJournalUnlocked] = React.useState(false);
  const [journalKey, setJournalKey]           = React.useState("");
  const [journalKeyInput, setJournalKeyInput] = React.useState("");
  const [journalEntries, setJournalEntries]   = React.useState([]);
  const [journalView, setJournalView]         = React.useState("list");
  const [journalEditing, setJournalEditing]   = React.useState(null);
  const [journalEditorTitle, setJournalEditorTitle] = React.useState("");
  const [journalEditorBody, setJournalEditorBody]   = React.useState("");
  const [journalSaveStatus, setJournalSaveStatus]   = React.useState("");
  const [journalUnlocking, setJournalUnlocking]     = React.useState(false);
  const [journalError, setJournalError]             = React.useState("");

  // Full Picture
  const [fpQuery, setFpQuery]     = React.useState("");
  const [fpLoading, setFpLoading] = React.useState(false);
  const [fpResults, setFpResults] = React.useState(null);
  const [fpError, setFpError]     = React.useState("");
  const [fpGuestCount, setFpGuestCount] = React.useState(() => getGuestSearchCount());

  // Challenge
  const [challengeScore, setChallengeScore] = React.useState(() => { try { return parseInt(localStorage.getItem("vc_score") || "0"); } catch { return 0; } });
  const [challengeData, setChallengeData]   = React.useState(null);
  const [challengeLoading, setChallengeLoading] = React.useState(false);
  const [challengeAnswered, setChallengeAnswered] = React.useState(false);
  const [challengeSelected, setChallengeSelected] = React.useState(null);
  const [challengeExample, setChallengeExample]   = React.useState("");
  const [challengeExampleDone, setChallengeExampleDone] = React.useState(false);

  // Reports
  const [reports, setReports]       = React.useState(() => loadReports());
  const [violations, setViolations] = React.useState(() => loadViolations());
  const [showReportModal, setShowReportModal] = React.useState(false);
  const [reportTarget, setReportTarget]       = React.useState(null);
  const [reportDesc, setReportDesc]           = React.useState("");
  const [reportLink, setReportLink]           = React.useState("");
  const [reportScreenshot, setReportScreenshot] = React.useState("");
  const [reportError, setReportError]           = React.useState("");
  const [reportSuccess, setReportSuccess]       = React.useState("");

  // Onboarding
  const [showOnboarding, setShowOnboarding] = React.useState(false);
  const [onboardingStep, setOnboardingStep] = React.useState(0);

  // Quote
  const [quoteData, setQuoteData] = React.useState(null);

  React.useEffect(() => { fetchFreedomQuote().then(setQuoteData).catch(() => {}); }, []);

  const currentUser = isAdmin
    ? { name: "Jacks Liver", handle: "@ViveLiber", avatar: "👑", photo: profilePhoto }
    : { name: signupName || "Voice", handle: "@voice", avatar: "👤", photo: profilePhoto };
  const userBadge = getBadge(challengeScore);
  const pendingReports = reports.filter(r => r.status === "pending").length;

  // ── Auth ──
  const handleLogin = () => {
    setAuthError("");
    if (!loginEmail.trim() || !loginPw.trim()) { setAuthError("Please enter email and password."); return; }
    if (loginEmail === ADMIN_EMAIL && loginPw === ADMIN_PASSWORD) { setIsAdmin(true); }
    setIsMember(true);
    const done = localStorage.getItem(ONBOARDING_KEY);
    if (!done) setShowOnboarding(true);
    setPage("feed");
  };
  const handleSignup = () => {
    setAuthError("");
    if (!signupName.trim()) { setAuthError("Please enter a display name."); return; }
    if (!loginEmail.trim()) { setAuthError("Please enter your email."); return; }
    if (!loginPw.trim() || loginPw.length < 8) { setAuthError("Password must be at least 8 characters."); return; }
    if (!tosChecked) { setTosError(true); return; }
    setTosError(false); setIsMember(true);
    setShowOnboarding(true);
    setPage("feed");
  };
  const finishOnboarding = () => {
    localStorage.setItem(ONBOARDING_KEY, "done");
    setShowOnboarding(false); setOnboardingStep(0);
  };

  // ── Compose ──
  const handleComposeChange = (e) => {
    const val = e.target.value;
    setComposeText(val);
    const cursor = e.target.selectionStart;
    const textUp = val.slice(0, cursor);
    const match = textUp.match(/@(\w*)$/);
    if (match) {
      const q = match[1].toLowerCase();
      const all = [{ name: "Jacks Liver", handle: "@ViveLiber", avatar: "👑" }, ...users.map(u => ({ name: u.name, handle: u.handle, avatar: u.avatar }))];
      setTagSuggestions(all.filter(u => u.handle.toLowerCase().includes(q) || u.name.toLowerCase().includes(q)).slice(0, 5));
    } else setTagSuggestions([]);
  };
  const insertTag = (handle) => {
    const cursor = composeRef.current?.selectionStart || composeText.length;
    const replaced = composeText.slice(0, cursor).replace(/@\w*$/, handle + " ");
    setComposeText(replaced + composeText.slice(cursor));
    setTagSuggestions([]);
  };
  const submitPost = () => {
    if (!composeText.trim()) return;
    if (!checkRateLimit("posts", 10, 3600000)) { alert("Posting too fast. Please slow down."); return; }
    const pollData = showPollBuilder && pollOptions.filter(o => o.trim()).length >= 2 ? {
      options: pollOptions.filter(o => o.trim()).map(o => ({ text: o, votes: 0 })),
      duration: pollDuration, votedBy: [], createdAt: Date.now(),
    } : null;
    let ac = anonCount;
    if (composeAnon) { ac++; setAnonCount(ac); }
    const np = {
      id: Date.now(), name: composeAnon ? "Anonymous" : currentUser.name,
      handle: composeAnon ? `@anon_${ac}` : currentUser.handle,
      avatar: composeAnon ? "🎭" : currentUser.avatar, photo: composeAnon ? "" : currentUser.photo,
      isOrg: false, isAdmin: isAdmin && !composeAnon, time: "now",
      body: composeText, hasImage: false, likes: 0, reposts: 0, comments: 0,
      liked: false, anonymous: composeAnon, poll: pollData, contentWarning: null,
    };
    setFeedPosts(prev => [np, ...prev.filter(p => p.pinned), ...prev.filter(p => !p.pinned)]);
    setAdminPosts(prev => [{ id: Date.now(), user: currentUser.handle, body: composeText, time: "now" }, ...prev]);
    setComposeText(""); setTagSuggestions([]); setShowPollBuilder(false);
    setPollOptions(["", "", "", ""]); setComposeAnon(false);
  };
  const toggleLike = (id) => setFeedPosts(prev => prev.map(p => p.id === id ? { ...p, liked: !p.liked, likes: p.liked ? p.likes - 1 : p.likes + 1 } : p));
  const toggleSave = (post) => {
    const already = savedPosts.find(s => s.id === post.id);
    const updated = already ? savedPosts.filter(s => s.id !== post.id) : [post, ...savedPosts];
    setSavedPosts(updated); saveSaved(updated);
  };
  const votePoll = (postId, optionIdx) => setFeedPosts(prev => prev.map(p => {
    if (p.id !== postId || !p.poll || p.poll.votedBy.includes(currentUser.handle)) return p;
    const options = p.poll.options.map((o, i) => i === optionIdx ? { ...o, votes: o.votes + 1 } : o);
    return { ...p, poll: { ...p.poll, options, votedBy: [...p.poll.votedBy, currentUser.handle] } };
  }));
  const toggleFollow = (handle) => setFollowedUsers(prev => prev.includes(handle) ? prev.filter(h => h !== handle) : [...prev, handle]);

  // ── Reports ──
  const openReport = (post) => {
    setReportTarget(post); setReportDesc(""); setReportLink(""); setReportScreenshot("");
    setReportError(""); setReportSuccess(""); setShowReportModal(true);
  };
  const submitReport = () => {
    if (!reportDesc.trim()) { setReportError("Please describe the violation."); return; }
    if (!reportLink.trim() && !reportScreenshot.trim()) { setReportError("Please provide a link or screenshot."); return; }
    if (!checkRateLimit("reports", 5, 86400000)) { setReportError("You have reached the daily report limit."); return; }
    const r = {
      id: Date.now().toString(), from: currentUser.handle, against: reportTarget?.handle || "unknown",
      postId: reportTarget?.id || null, postBody: reportTarget?.body?.slice(0, 80) || "",
      desc: reportDesc, link: reportLink, screenshot: reportScreenshot, status: "pending",
      date: new Date().toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })
    };
    const updated = [r, ...reports]; saveReports(updated); setReports(updated);
    setReportSuccess("Report submitted. Our team will review it within 24 hours.");
    setTimeout(() => setShowReportModal(false), 2500);
  };
  const approveReport = (rId) => {
    const r = reports.find(x => x.id === rId); if (!r) return;
    const updated = reports.map(x => x.id === rId ? { ...x, status: "approved" } : x);
    saveReports(updated); setReports(updated);
    const v = { ...violations };
    if (!v[r.against]) v[r.against] = { count: 0, history: [] };
    v[r.against].count += 1;
    v[r.against].history.push({ date: new Date().toISOString(), desc: r.desc });
    if (v[r.against].count >= 3) {
      setUsers(prev => prev.filter(u => u.handle !== r.against));
      setFeedPosts(prev => prev.filter(p => p.handle !== r.against));
    } else {
      const until = Date.now() + 86400000;
      v[r.against].restrictedUntil = until;
      setUsers(prev => prev.map(u => u.handle === r.against ? { ...u, restricted: true, restrictedUntil: until } : u));
    }
    saveViolations(v); setViolations(v);
  };
  const dismissReport = (rId) => {
    const updated = reports.map(r => r.id === rId ? { ...r, status: "dismissed" } : r);
    saveReports(updated); setReports(updated);
  };

  // ── Journal ──
  const handleJournalUnlock = React.useCallback(async () => {
    if (!journalKeyInput.trim()) { setJournalError("Please enter a passphrase."); return; }
    setJournalUnlocking(true); setJournalError("");
    try {
      const stored = loadJournal(); const dec = [];
      for (const e of stored) {
        try { dec.push({ id: e.id, date: e.date, title: await decryptText(e.encTitle, journalKeyInput), body: await decryptText(e.encBody, journalKeyInput) }); }
        catch { setJournalError("Wrong passphrase."); setJournalUnlocking(false); return; }
      }
      setJournalKey(journalKeyInput); setJournalEntries(dec); setJournalUnlocked(true);
    } catch { setJournalError("Something went wrong. Please try again."); }
    setJournalUnlocking(false);
  }, [journalKeyInput]);

  const handleJournalSave = React.useCallback(async () => {
    if (!journalEditorTitle.trim() && !journalEditorBody.trim()) return;
    setJournalSaveStatus("saving");
    try {
      const encTitle = await encryptText(journalEditorTitle || "(untitled)", journalKey);
      const encBody  = await encryptText(journalEditorBody, journalKey);
      const stored = loadJournal();
      const now = new Date().toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" });
      if (journalEditing) {
        saveJournal(stored.map(e => e.id === journalEditing.id ? { ...e, encTitle, encBody, date: now } : e));
        setJournalEntries(prev => prev.map(e => e.id === journalEditing.id ? { ...e, title: journalEditorTitle, body: journalEditorBody, date: now } : e));
        setJournalEditing(prev => ({ ...prev, title: journalEditorTitle, body: journalEditorBody, date: now }));
      } else {
        const id = Date.now().toString();
        saveJournal([{ id, encTitle, encBody, date: now }, ...stored]);
        const ne = { id, date: now, title: journalEditorTitle || "(untitled)", body: journalEditorBody };
        setJournalEntries(prev => [ne, ...prev]); setJournalEditing(ne);
      }
      setJournalSaveStatus("saved");
    } catch { setJournalSaveStatus(""); }
  }, [journalEditorTitle, journalEditorBody, journalKey, journalEditing]);

  const downloadJournalDocx = async () => {
    if (journalEntries.length === 0) { alert("No entries to download."); return; }
    try {
      if (!window.docx) await new Promise((res, rej) => { const s = document.createElement("script"); s.src = "https://cdnjs.cloudflare.com/ajax/libs/docx/8.5.0/docx.umd.min.js"; s.onload = res; s.onerror = rej; document.head.appendChild(s); });
      const { Document, Packer, Paragraph, TextRun, AlignmentType, PageBreak, BorderStyle } = window.docx;
      const children = [];
      children.push(
        new Paragraph({ alignment: AlignmentType.CENTER, spacing: { before: 2880, after: 480 }, children: [new TextRun({ text: "VERITAS CRUDA", font: "Georgia", size: 52, bold: true, color: "C9A84C" })] }),
        new Paragraph({ alignment: AlignmentType.CENTER, spacing: { before: 0, after: 240 }, children: [new TextRun({ text: "Private Journal", font: "Georgia", size: 36, italics: true, color: "4A4A4A" })] }),
        new Paragraph({ alignment: AlignmentType.CENTER, spacing: { before: 0, after: 240 }, children: [new TextRun({ text: currentUser.name, font: "Georgia", size: 28 })] }),
        new Paragraph({ alignment: AlignmentType.CENTER, spacing: { before: 0, after: 480 }, children: [new TextRun({ text: `Downloaded ${new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}`, font: "Courier New", size: 20, color: "888888" })] }),
        new Paragraph({ children: [new PageBreak()] })
      );
      journalEntries.forEach((entry, idx) => {
        if (idx > 0) children.push(new Paragraph({ children: [new PageBreak()] }));
        children.push(
          new Paragraph({ spacing: { before: 480, after: 120 }, border: { bottom: { style: BorderStyle.SINGLE, size: 6, color: "C9A84C", space: 1 } }, children: [new TextRun({ text: entry.title || "(Untitled)", font: "Georgia", size: 40, bold: true })] }),
          new Paragraph({ spacing: { before: 120, after: 240 }, children: [new TextRun({ text: entry.date, font: "Courier New", size: 18, color: "C9A84C" })] }),
          ...(entry.body || "").split("\n").map(line => new Paragraph({ spacing: { after: 160 }, children: [new TextRun({ text: line, font: "Georgia", size: 24, color: "2E1F24" })] }))
        );
      });
      const doc = new Document({ sections: [{ properties: { page: { size: { width: 12240, height: 15840 }, margin: { top: 1440, right: 1440, bottom: 1440, left: 1440 } } }, children }] });
      const blob = new Blob([await Packer.toBuffer(doc)], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a"); a.href = url;
      a.download = `VeritasCruda_Journal_${currentUser.name.replace(/ /g, "_")}.docx`;
      a.click(); URL.revokeObjectURL(url);
    } catch (e) { alert("Download failed. Please try again."); console.error(e); }
  };

  // ── Challenge ──
  const loadChallenge = React.useCallback(async () => {
    setChallengeLoading(true);
    try {
      const data = await fetchDailyChallenge(); setChallengeData(data);
      const today = new Date().toISOString().split("T")[0];
      const answered = localStorage.getItem(`vc_answered_${today}`);
      if (answered) { setChallengeAnswered(true); setChallengeSelected(answered); }
      else { setChallengeAnswered(false); setChallengeSelected(null); setChallengeExample(""); setChallengeExampleDone(false); }
    } catch (e) { console.error(e); }
    setChallengeLoading(false);
  }, []);
  React.useEffect(() => { if (page === "challenge") loadChallenge(); }, [page, loadChallenge]);

  const answerChallenge = (opt) => {
    if (challengeAnswered || !challengeData) return;
    setChallengeSelected(opt); setChallengeAnswered(true);
    localStorage.setItem(`vc_answered_${new Date().toISOString().split("T")[0]}`, opt);
    if (opt.startsWith(challengeData.correct)) {
      const ns = challengeScore + 1; setChallengeScore(ns); localStorage.setItem("vc_score", String(ns));
    }
  };
  const submitChallengeExample = () => {
    if (!challengeExample.trim() || challengeExampleDone) return;
    setChallengeExampleDone(true);
    const ns = challengeScore + 1; setChallengeScore(ns); localStorage.setItem("vc_score", String(ns));
  };

  // ── Full Picture ──
  const handleFPSearch = React.useCallback(async () => {
    if (!fpQuery.trim()) return;
    if (!isMember && getGuestSearchCount() >= GUEST_SEARCH_LIMIT) { setFpError(`You've used all ${GUEST_SEARCH_LIMIT} free searches this month.`); return; }
    setFpLoading(true); setFpResults(null); setFpError("");
    try {
      if (!isMember) setFpGuestCount(incrementGuestSearch());
      setFpResults(await fetchFullPicture(fpQuery));
    } catch { setFpError("Could not retrieve results. Please try again."); }
    setFpLoading(false);
  }, [fpQuery, isMember]);

  // ── Admin ──
  const toggleBan  = (id) => setUsers(prev => prev.map(u => u.id === id ? { ...u, banned: !u.banned } : u));
  const deletePost = (id) => { setAdminPosts(prev => prev.filter(p => p.id !== id)); setFeedPosts(prev => prev.filter(p => p.id !== id)); };

  // ─── Nav helper ───────────────────────────────────────────────────────────────
  const navigate = (id) => {
    setNavActive(id);
    if (["profile","journal","fullpicture","challenge","saved"].includes(id)) setPage(id);
    else setPage("feed");
  };

  const navItems = [
    { id: "feed",          icon: "🏠", label: "Feed" },
    { id: "explore",       icon: "🔍", label: "Explore" },
    { id: "notifications", icon: "🔔", label: "Notifications" },
    { id: "messages",      icon: "✉️",  label: "Messages" },
    { id: "organizations", icon: "🏛",  label: "Organizations" },
    { id: "challenge",     icon: "⚡", label: "Freedom Challenge" },
    { id: "journal",       icon: "📖", label: "My Journal" },
    { id: "saved",         icon: "🔖", label: "Saved" },
    { id: "profile",       icon: "👤", label: "Profile" },
  ];

  // ─── TOS page ─────────────────────────────────────────────────────────────────
  // ─── Landing page ─────────────────────────────────────────────────────────────
  if (page === "landing") return (
    <><style>{STYLES}</style>
    <style>{`
      .lp-body { background:#0D1B2A; color:#F4EFE6; font-family:'EB Garamond',serif; min-height:100vh; }
      .lp-nav { position:fixed; top:0; left:0; right:0; z-index:100; background:rgba(13,27,42,0.96); backdrop-filter:blur(12px); border-bottom:1px solid rgba(201,168,76,0.22); padding:16px 40px; display:flex; align-items:center; justify-content:space-between; }
      .lp-nav-logo { font-family:'Cinzel',serif; font-size:18px; font-weight:900; letter-spacing:0.06em; }
      .lp-nav-links { display:flex; align-items:center; gap:32px; }
      .lp-nav-link { font-family:'DM Mono',monospace; font-size:11px; letter-spacing:0.15em; color:#7A8FA6; text-decoration:none; text-transform:uppercase; cursor:pointer; transition:color 0.2s; background:none; border:none; padding:0; }
      .lp-nav-link:hover { color:#C9A84C; }
      .lp-enter-btn { background:#C9A84C; color:#0D1B2A; padding:10px 24px; border-radius:6px; font-family:'Cinzel',serif; font-size:12px; font-weight:700; letter-spacing:0.1em; cursor:pointer; border:none; transition:all 0.2s; }
      .lp-enter-btn:hover { background:#E2C47A; transform:translateY(-1px); }
      .lp-hero { min-height:100vh; display:flex; align-items:center; justify-content:center; text-align:center; padding:120px 40px 80px; background:radial-gradient(ellipse at 30% 40%,rgba(201,168,76,0.08) 0%,transparent 60%); }
      .lp-hero-inner { max-width:800px; }
      .lp-eyebrow { font-family:'DM Mono',monospace; font-size:11px; letter-spacing:0.3em; color:#C9A84C; text-transform:uppercase; margin-bottom:24px; }
      .lp-title { font-family:'Cinzel',serif; font-size:clamp(42px,7vw,84px); font-weight:900; line-height:1.05; letter-spacing:0.03em; margin-bottom:24px; }
      .lp-title span { color:#C9A84C; }
      .lp-tagline { font-size:20px; color:#9DB0C4; line-height:1.7; margin-bottom:32px; font-style:italic; }
      .lp-warning { background:rgba(231,76,60,0.08); border:1px solid rgba(231,76,60,0.25); border-radius:10px; padding:20px 28px; margin:0 auto 40px; max-width:640px; font-family:'DM Mono',monospace; font-size:11px; color:#E88; letter-spacing:0.06em; line-height:1.9; text-align:left; }
      .lp-warning strong { color:#E74C3C; display:block; margin-bottom:8px; font-size:12px; letter-spacing:0.15em; }
      .lp-btns { display:flex; gap:16px; justify-content:center; flex-wrap:wrap; }
      .lp-btn-primary { background:#C9A84C; color:#0D1B2A; padding:16px 40px; border-radius:8px; font-family:'Cinzel',serif; font-size:15px; font-weight:700; letter-spacing:0.1em; cursor:pointer; border:none; transition:all 0.2s; }
      .lp-btn-primary:hover { background:#E2C47A; transform:translateY(-2px); box-shadow:0 8px 24px rgba(201,168,76,0.3); }
      .lp-pledge { padding:80px 40px; text-align:center; border-top:1px solid rgba(201,168,76,0.22); border-bottom:1px solid rgba(201,168,76,0.22); background:#122236; }
      .lp-pledge-title { font-family:'Cinzel',serif; font-size:clamp(24px,4vw,42px); font-weight:900; margin-bottom:20px; }
      .lp-pledge-title span { color:#C9A84C; }
      .lp-pledge-text { font-size:18px; color:#9DB0C4; line-height:1.8; max-width:680px; margin:0 auto 24px; }
      .lp-pledge-box { font-family:'DM Mono',monospace; font-size:13px; color:#C9A84C; letter-spacing:0.1em; line-height:2; max-width:600px; margin:0 auto; border-top:1px solid rgba(201,168,76,0.22); padding-top:24px; }
      .lp-pledge-sig { margin-top:24px; font-family:'Cinzel',serif; font-size:14px; color:#7A8FA6; }
      .lp-features { padding:100px 40px; max-width:1200px; margin:0 auto; }
      .lp-section-label { font-family:'DM Mono',monospace; font-size:10px; letter-spacing:0.3em; color:#C9A84C; text-transform:uppercase; text-align:center; margin-bottom:16px; }
      .lp-section-title { font-family:'Cinzel',serif; font-size:clamp(28px,4vw,48px); font-weight:900; text-align:center; margin-bottom:60px; }
      .lp-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(300px,1fr)); gap:24px; }
      .lp-card { background:#122236; border:1px solid rgba(201,168,76,0.22); border-radius:16px; padding:32px; transition:all 0.2s; }
      .lp-card:hover { border-color:rgba(201,168,76,0.4); transform:translateY(-4px); }
      .lp-card-icon { font-size:32px; margin-bottom:16px; }
      .lp-card-title { font-family:'Cinzel',serif; font-size:18px; font-weight:700; color:#C9A84C; margin-bottom:10px; }
      .lp-card-desc { font-size:15px; color:#9DB0C4; line-height:1.7; }
      .lp-tribuna { padding:100px 40px; background:#122236; border-top:1px solid rgba(201,168,76,0.22); text-align:center; }
      .lp-tribuna-title { font-family:'Cinzel',serif; font-size:clamp(32px,5vw,64px); font-weight:900; color:#C9A84C; margin-bottom:16px; letter-spacing:0.08em; }
      .lp-tribuna-sub { font-family:'DM Mono',monospace; font-size:11px; letter-spacing:0.25em; color:#7A8FA6; text-transform:uppercase; margin-bottom:24px; }
      .lp-tribuna-desc { font-size:18px; color:#9DB0C4; line-height:1.8; max-width:640px; margin:0 auto 40px; }
      .lp-awards { padding:100px 40px; max-width:1100px; margin:0 auto; text-align:center; }
      .lp-awards-row { display:flex; justify-content:center; gap:20px; flex-wrap:wrap; margin-top:48px; }
      .lp-award { background:#122236; border:1px solid rgba(201,168,76,0.22); border-radius:14px; padding:28px 24px; width:170px; transition:all 0.2s; }
      .lp-award:hover { transform:translateY(-6px); border-color:rgba(201,168,76,0.4); }
      .lp-award.special { border-color:rgba(201,168,76,0.4); }
      .lp-award-icon { font-size:36px; margin-bottom:12px; }
      .lp-award-name { font-family:'Cinzel',serif; font-size:13px; font-weight:700; color:#C9A84C; margin-bottom:6px; }
      .lp-award-milestone { font-family:'DM Mono',monospace; font-size:10px; color:#7A8FA6; }
      .lp-cta { padding:120px 40px; text-align:center; }
      .lp-cta-title { font-family:'Cinzel',serif; font-size:clamp(32px,5vw,60px); font-weight:900; margin-bottom:16px; }
      .lp-cta-title span { color:#C9A84C; }
      .lp-cta-sub { font-size:18px; color:#9DB0C4; margin-bottom:40px; font-style:italic; }
      .lp-footer { padding:40px; border-top:1px solid rgba(201,168,76,0.22); display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:16px; }
      .lp-footer-logo { font-family:'Cinzel',serif; font-size:14px; font-weight:900; }
      .lp-footer-links { display:flex; gap:24px; }
      .lp-footer-link { font-family:'DM Mono',monospace; font-size:10px; letter-spacing:0.15em; color:#7A8FA6; text-decoration:none; text-transform:uppercase; cursor:pointer; background:none; border:none; padding:0; transition:color 0.2s; }
      .lp-footer-link:hover { color:#C9A84C; }
      .lp-footer-copy { font-family:'DM Mono',monospace; font-size:10px; color:#7A8FA6; }
      @media(max-width:768px){ .lp-nav-links{display:none;} .lp-hero{padding:100px 24px 60px;} .lp-footer{flex-direction:column;text-align:center;} }
    `}</style>
    <div className="lp-body">

      <nav className="lp-nav">
        <div className="lp-nav-logo"><span style={{color:"#C9A84C"}}>Veritas</span> <span style={{color:"white"}}>Cruda</span></div>
        <div className="lp-nav-links">
          <button className="lp-nav-link" onClick={()=>document.getElementById('lp-features')?.scrollIntoView({behavior:'smooth'})}>Features</button>
          <button className="lp-nav-link" onClick={()=>document.getElementById('lp-tribuna')?.scrollIntoView({behavior:'smooth'})}>Tribuna</button>
          <button className="lp-nav-link" onClick={()=>document.getElementById('lp-pledge')?.scrollIntoView({behavior:'smooth'})}>Our Pledge</button>
          <button className="lp-enter-btn" onClick={()=>setPage("auth")}>Enter</button>
        </div>
      </nav>

      <section className="lp-hero">
        <div className="lp-hero-inner">
          <div className="lp-eyebrow">The Raw Truth · Unfiltered</div>
          <h1 className="lp-title"><span>Veritas</span> Cruda</h1>
          <p className="lp-tagline">"Where Voices Stand. Where Truth Lives. Where Freedom Is Not Negotiable."</p>
          <div className="lp-warning">
            <strong>⚠ READ BEFORE YOU ENTER</strong>
            This platform is built on the principle of absolute freedom of speech. You will encounter opinions, language, and content that you may find offensive, disagreeable, rude, or uncomfortable. That is not a bug. That is the point.<br/><br/>
            If you cannot handle what people say without restriction, this is not the platform for you. Thick skin is not optional here — it is required.<br/><br/>
            The only content prohibited: racism and hate speech, direct threats of violence, CSAM, and terrorism-affiliated content. Everything else is the sole responsibility of the person who posts it.
          </div>
          <div className="lp-btns">
            <button className="lp-btn-primary" onClick={()=>setPage("auth")}>Enter Veritas Cruda</button>
          </div>
        </div>
      </section>

      <section className="lp-pledge" id="lp-pledge">
        <div style={{fontFamily:"DM Mono,monospace",fontSize:10,letterSpacing:"0.2em",color:"#C9A84C",textTransform:"uppercase",marginBottom:16}}>Our Founding Pledge</div>
        <div className="lp-pledge-title">We Will <span>Never</span> Sell Your Data</div>
        <p className="lp-pledge-text">Not to advertisers. Not to governments. Not to AI companies. Not to data brokers. Not to anyone. Ever. Under any circumstances.</p>
        <div className="lp-pledge-box">
          This is not a policy we can quietly update.<br/>
          This is not a terms of service clause with hidden exceptions.<br/>
          This is a founding promise that exists before the law and beyond it.<br/><br/>
          Your data belongs to you. It will never belong to us to sell.
        </div>
        <div className="lp-pledge-sig">— Jacks Liver, @ViveLiber · Founder, Veritas Cruda</div>
      </section>

      <section className="lp-features" id="lp-features">
        <div className="lp-section-label">What Makes Us Different</div>
        <div className="lp-section-title">Built For Freedom. Built For Truth.</div>
        <div className="lp-grid">
          {[
            {icon:"🔒",title:"Zero Data Selling",desc:"We never sell share or license your private data to anyone under any circumstances. Not even the platform owner has access."},
            {icon:"📰",title:"No Algorithm Manipulation",desc:"Your feed is chronological. No hidden algorithm. No engagement bait. No outrage amplification. Posts in the order they were made."},
            {icon:"🔎",title:"Full Picture",desc:"AI-powered truth search. Type any topic and get only verified sourced facts stripped of spin from every side."},
            {icon:"📖",title:"Private Encrypted Journal",desc:"AES-256 encrypted in your browser. Not even Veritas Cruda can read your entries. Truly private by design not policy."},
            {icon:"🎙️",title:"TRIBUNA",desc:"A YouTube-style video section built for Voices. Upload build your audience earn fair revenue. You keep the majority."},
            {icon:"⚡",title:"Daily Freedom Challenge",desc:"A new question about freedom and world history every day. Answer correctly earn your title from Truth Seeker to Keeper of the Flame."},
            {icon:"👨‍👩‍👧",title:"Parental Controls",desc:"Triple-lock parental controls for under-16. PIN protected parent account linked auto-lifts on the childs 16th birthday."},
            {icon:"✅",title:"Verified Human Badge",desc:"In a world flooded with AI bots earn a Verified Human badge that proves to your audience they are talking to a real person."},
            {icon:"🏛",title:"Free Speech. Real Rules.",desc:"Only three things are banned: racism hate speech direct threats and CSAM. Everything else is your responsibility and your right."},
          ].map((f,i)=>(
            <div key={i} className="lp-card">
              <div className="lp-card-icon">{f.icon}</div>
              <div className="lp-card-title">{f.title}</div>
              <div className="lp-card-desc">{f.desc}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="lp-tribuna" id="lp-tribuna">
        <div className="lp-section-label">Video Platform</div>
        <div className="lp-tribuna-title">TRIBUNA</div>
        <div className="lp-tribuna-sub">Where Voices Stand</div>
        <p className="lp-tribuna-desc">A full YouTube-style video platform built inside Veritas Cruda. Upload long-form content build your Voice page grow your audience earn fair revenue. Every frame of it yours.</p>
        <div style={{background:"rgba(201,168,76,0.06)",border:"1px solid rgba(201,168,76,0.22)",borderRadius:10,padding:"16px 24px",fontFamily:"DM Mono,monospace",fontSize:10,color:"#7A8FA6",letterSpacing:"0.08em",lineHeight:1.8,maxWidth:640,margin:"0 auto"}}>
          "The content presented in any Tribuna video is the sole expression and opinion of the Voice who created it. It does not represent the views positions or beliefs of Veritas Cruda or its founders."
        </div>
      </section>

      <section className="lp-awards">
        <div className="lp-section-label">Voice Recognition</div>
        <div className="lp-section-title">The Eagle and the Chain</div>
        <p style={{fontSize:17,color:"#9DB0C4",maxWidth:600,margin:"0 auto",lineHeight:1.8}}>Physical awards for Voices who build real audiences on Tribuna. An eagle in full flight carrying a broken chain in its talons.</p>
        <div className="lp-awards-row">
          {[
            {icon:"🥉",name:"Bronze Eagle",milestone:"1,000 Followers"},
            {icon:"🥈",name:"Silver Eagle",milestone:"10,000 Followers"},
            {icon:"🥇",name:"Gold Eagle",milestone:"100,000 Followers"},
            {icon:"⚡",name:"Sovereign Eagle",milestone:"1,000,000 Followers"},
            {icon:"🦅",name:"The Unchained Eagle",milestone:"Awarded by @ViveLiber\nDelivered in person",special:true},
          ].map((a,i)=>(
            <div key={i} className={`lp-award${a.special?" special":""}`}>
              <div className="lp-award-icon">{a.icon}</div>
              <div className="lp-award-name">{a.name}</div>
              <div className="lp-award-milestone" style={{whiteSpace:"pre-line"}}>{a.milestone}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="lp-cta">
        <div className="lp-cta-title">Ready to Speak <span>Without Fear?</span></div>
        <p className="lp-cta-sub">Join the platform where your data is safe your voice is free and the truth is all that matters.</p>
        <button className="lp-btn-primary" onClick={()=>setPage("auth")}>Enter Veritas Cruda</button>
      </section>

      <footer className="lp-footer">
        <div className="lp-footer-logo"><span style={{color:"#C9A84C"}}>Veritas</span> <span style={{color:"white"}}>Cruda</span></div>
        <div className="lp-footer-links">
          <button className="lp-footer-link" onClick={()=>{setPrevPage("landing");setPage("tos");}}>Terms of Service</button>
          <button className="lp-footer-link" onClick={()=>setPage("auth")}>Enter Platform</button>
        </div>
        <div className="lp-footer-copy">© 2026 Veritas Cruda · The Raw Truth, Unfiltered</div>
      </footer>

    </div>
    </>
  );

  if (page === "tos") return (
    <><style>{STYLES}</style>
    <div className="tos-page">
      <button className="tos-back" onClick={() => setPage(prevPage)}>← Back</button>
      <div className="tos-title"><span style={{ color: "var(--gold)" }}>Veritas</span> Cruda Terms of Service</div>
      <div className="tos-date">EFFECTIVE DATE: APRIL 12, 2026</div>
      <div className="tos-body">{TOS_TEXT}</div>
    </div></>
  );

  // ─── Auth page ────────────────────────────────────────────────────────────────
  if (page === "auth") return (
    <><style>{STYLES}</style>
    <div className="auth-screen">
      <div className="auth-bg" />
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-text"><span style={{ color: "var(--gold)" }}>Veritas</span> <span style={{ color: "white" }}>Cruda</span></div>
          <div style={{ textAlign: "center", fontFamily: "DM Mono,monospace", fontSize: 9, color: "var(--muted)", letterSpacing: "0.22em", marginTop: 6 }}>THE RAW TRUTH · UNFILTERED</div>
        </div>
        <div className="auth-warning">
          <strong>⚠ THICK SKIN REQUIRED</strong>
          This platform is built on true freedom of speech. You will encounter content that is offensive, rude, and disagreeable. If you cannot handle that this is not your platform. By entering you accept full responsibility for your own experience.
        </div>
        <div className="auth-tabs">
          <div className={`auth-tab${authTab === "login" ? " active" : ""}`} onClick={() => { setAuthTab("login"); setAuthError(""); }}>Sign In</div>
          <div className={`auth-tab${authTab === "signup" ? " active" : ""}`} onClick={() => { setAuthTab("signup"); setAuthError(""); setTosError(false); }}>Join</div>
        </div>
        {authTab === "signup" && <div className="auth-field"><label className="auth-label">Display Name</label><input className="auth-input" placeholder="Your name" value={signupName} onChange={e => setSignupName(e.target.value)} /></div>}
        <div className="auth-field"><label className="auth-label">Email</label><input className="auth-input" type="email" placeholder="you@example.com" value={loginEmail} onChange={e => setLoginEmail(e.target.value)} /></div>
        <div className="auth-field"><label className="auth-label">Password</label><input className="auth-input" type="password" placeholder="••••••••" value={loginPw} onChange={e => setLoginPw(e.target.value)} /></div>
        {authTab === "signup" && (
          <div style={{ display: "flex", alignItems: "flex-start", gap: 10, marginBottom: 12 }}>
            <input type="checkbox" id="tos" checked={tosChecked} onChange={e => { setTosChecked(e.target.checked); setTosError(false); }} style={{ marginTop: 3, accentColor: "var(--gold)", cursor: "pointer", width: 16, height: 16, flexShrink: 0 }} />
            <label htmlFor="tos" style={{ fontSize: 13, color: tosError ? "var(--red)" : "var(--muted-light)", lineHeight: 1.5, cursor: "pointer" }}>
              I have read and agree to the <span onClick={() => { setPrevPage("auth"); setPage("tos"); }} style={{ color: "var(--gold)", textDecoration: "underline", cursor: "pointer" }}>Terms of Service</span>. I accept full responsibility for my actions on Veritas Cruda.
            </label>
          </div>
        )}
        {tosError && <div className="auth-error">⚠ You must agree to the Terms of Service</div>}
        {authError && <div className="auth-error">⚠ {authError}</div>}
        <button className="auth-submit" onClick={() => authTab === "login" ? handleLogin() : handleSignup()}>
          {authTab === "login" ? "Enter Veritas Cruda" : "Create Account"}
        </button>
        <div className="auth-divider">— or —</div>
        <div style={{ textAlign: "center", fontSize: 13, color: "var(--muted)", cursor: "pointer" }} onClick={() => { setIsMember(false); setPage("feed"); }}>Continue as guest →</div>
      </div>
    </div></>
  );



  // ─── Main App render ──────────────────────────────────────────────────────────
  return (
    <><style>{STYLES}</style>

    {/* ONBOARDING */}
    {showOnboarding && (
      <div className="onboarding-overlay">
        <div className="onboarding-card">
          <div className="onboarding-step">Step {onboardingStep + 1} of {ONBOARDING_STEPS.length}</div>
          <div className="onboarding-title">{ONBOARDING_STEPS[onboardingStep].title}</div>
          <div className="onboarding-body">{ONBOARDING_STEPS[onboardingStep].body}</div>
          <div className="onboarding-nav">
            <button className="onboarding-skip" onClick={finishOnboarding}>Skip</button>
            <div className="onboarding-dots">
              {ONBOARDING_STEPS.map((_, i) => <div key={i} className={`onboarding-dot${i === onboardingStep ? " active" : ""}`} />)}
            </div>
            <button className="onboarding-next" onClick={() => { if (onboardingStep < ONBOARDING_STEPS.length - 1) setOnboardingStep(s => s + 1); else finishOnboarding(); }}>
              {onboardingStep < ONBOARDING_STEPS.length - 1 ? "Next →" : "Get Started"}
            </button>
          </div>
        </div>
      </div>
    )}

    {/* REPORT MODAL */}
    {showReportModal && (
      <div className="modal-overlay" onClick={e => { if (e.target === e.currentTarget) setShowReportModal(false); }}>
        <div className="modal">
          <div className="modal-title">File a Report</div>
          <div className="modal-sub">Against: {reportTarget?.handle}</div>
          <div className="modal-warning"><span>⚠ NOTE:</span> False reports may result in action against your account. 3 violations = permanent ban, no appeal.</div>
          <div className="modal-field"><label className="modal-label">Describe the Violation</label><textarea className="modal-textarea" placeholder="Describe what happened and why it violates the Terms of Service…" value={reportDesc} onChange={e => setReportDesc(e.target.value)} /></div>
          <div className="modal-field"><label className="modal-label">Link to Offense (public posts)</label><input className="modal-input" placeholder="https://…" value={reportLink} onChange={e => setReportLink(e.target.value)} /></div>
          <div className="modal-field"><label className="modal-label">Screenshot URL (DMs)</label><input className="modal-input" placeholder="https://imgur.com/…" value={reportScreenshot} onChange={e => setReportScreenshot(e.target.value)} /></div>
          {reportError && <div className="modal-error">⚠ {reportError}</div>}
          {reportSuccess && <div className="modal-success">✓ {reportSuccess}</div>}
          <div className="modal-actions">
            <button className="modal-cancel" onClick={() => setShowReportModal(false)}>Cancel</button>
            <button className="modal-submit" onClick={submitReport}>Submit Report</button>
          </div>
        </div>
      </div>
    )}

    <div className="app">
      {/* SIDEBAR */}
      <div className="sidebar">
        <div className="logo">
          <div className="logo-text"><span className="logo-veritas">Veritas</span> <span className="logo-cruda">Cruda</span></div>
          <div className="logo-tagline">The Raw Truth · Unfiltered</div>
        </div>
        <nav className="nav">
          {navItems.map(item => (
            <div key={item.id} className={`nav-item${navActive === item.id ? " active" : ""}`} onClick={() => navigate(item.id)}>
              <span className="nav-icon">{item.icon}</span>
              <span>{item.label}</span>
              {item.id === "notifications" && pendingReports > 0 && isAdmin && <span className="nav-badge">{pendingReports}</span>}
            </div>
          ))}
        </nav>
        {page === "profile" && (
          <div style={{ padding: "12px 16px", borderTop: "1px solid var(--border)", display: "flex", flexDirection: "column", gap: 8 }}>
            <button onClick={() => setShowCustomize(!showCustomize)} style={{ background: "transparent", border: "1px solid var(--gold)", color: "var(--gold)", padding: 8, borderRadius: 8, fontFamily: "DM Mono,monospace", fontSize: 11, letterSpacing: "0.08em", cursor: "pointer", textAlign: "center" }}>
              {showCustomize ? "✦ DONE" : "✦ CUSTOMIZE"}
            </button>
            <button onClick={() => { setOnboardingStep(0); setShowOnboarding(true); }} style={{ background: "transparent", border: "1px solid var(--border)", color: "var(--muted)", padding: 8, borderRadius: 8, fontFamily: "DM Mono,monospace", fontSize: 11, cursor: "pointer", textAlign: "center" }}>
              📖 Tutorial
            </button>
          </div>
        )}
        {/* CYPHER BUTTON — bottom left, green, powered by Cypher */}
        <div
          onClick={() => navigate("fullpicture")}
          style={{
            margin: "0 16px 8px",
            background: "rgba(46,204,113,0.1)",
            border: "1px solid rgba(46,204,113,0.4)",
            borderRadius: 8,
            padding: "10px 16px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 10,
            transition: "all 0.2s",
          }}
          onMouseEnter={e => e.currentTarget.style.background = "rgba(46,204,113,0.2)"}
          onMouseLeave={e => e.currentTarget.style.background = "rgba(46,204,113,0.1)"}
        >
          <span style={{ fontSize: 16 }}>🔎</span>
          <div>
            <div style={{ fontFamily: "Cinzel,serif", fontSize: 13, fontWeight: 900, color: "#2ECC71", letterSpacing: "0.15em" }}>CYPHER</div>
            <div style={{ fontFamily: "DM Mono,monospace", fontSize: 9, color: "rgba(46,204,113,0.7)", letterSpacing: "0.1em", marginTop: 2 }}>FACT CHECK · ZERO BIAS</div>
          </div>
        </div>

        <div className="sidebar-profile" onClick={() => navigate("profile")}>
          <div className="sidebar-avatar">{profilePhoto ? <img src={profilePhoto} alt="" /> : currentUser.avatar}</div>
          <div>
            <div className="sidebar-name">{currentUser.name}</div>
            <div className="sidebar-handle">{currentUser.handle}</div>
            <div className="sidebar-badge">{userBadge.icon} {userBadge.label}</div>
          </div>
        </div>
      </div>

      <div className="main">

        {/* SAVED */}
        {page === "saved" ? (
          <div className="saved-page">
            <div className="saved-header"><div className="saved-title">🔖 Saved Posts</div></div>
            <div className="scrollable">
              {savedPosts.length === 0
                ? <div style={{ padding: "60px 24px", textAlign: "center", color: "var(--muted)", fontStyle: "italic", fontSize: 16 }}>No saved posts yet. Tap the bookmark icon on any post to save it.</div>
                : savedPosts.map(post => <PostCard key={post.id} post={post} onLike={toggleLike} onReport={openReport} onSave={toggleSave} onVotePoll={votePoll} savedPosts={savedPosts} currentUser={currentUser} />)
              }
            </div>
          </div>

        ) : page === "challenge" ? (
          /* FREEDOM CHALLENGE */
          <div className="challenge-page">
            <div className="challenge-header">
              <div className="challenge-title-text">⚡ Daily Freedom Challenge</div>
              <div className="challenge-subtitle">New question every midnight · Freedom and World History</div>
            </div>
            <div className="challenge-body">
              <div className="challenge-score-card">
                <div><div className="challenge-score-label">Your Score</div><div className="challenge-score-val">{challengeScore}</div></div>
                <div style={{ textAlign: "right" }}><div className="challenge-score-label">Title</div><div style={{ fontFamily: "DM Mono,monospace", fontSize: 14, color: "var(--gold)", marginTop: 4 }}>{userBadge.icon} {userBadge.label}</div></div>
              </div>
              {challengeLoading ? (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12, padding: 60, color: "var(--muted)", fontFamily: "DM Mono,monospace", fontSize: 11, letterSpacing: "0.15em" }}>
                  <div className="fp-spinner" />Loading today's challenge…
                </div>
              ) : challengeData ? (
                <div className="challenge-card">
                  <div className="challenge-category">{challengeData.category}</div>
                  <div className="challenge-question">{challengeData.question}</div>
                  <div className="challenge-options">
                    {challengeData.options.map((opt, i) => {
                      let cls = "challenge-option";
                      if (challengeAnswered) {
                        if (opt.startsWith(challengeData.correct)) cls += " correct";
                        else if (opt === challengeSelected) cls += " wrong";
                        cls += " disabled";
                      }
                      return <button key={i} className={cls} onClick={() => answerChallenge(opt)} disabled={challengeAnswered}>{opt}</button>;
                    })}
                  </div>
                  {challengeAnswered && (
                    <>
                      <div className="challenge-explanation" style={{ marginTop: 20 }}>
                        {challengeData.explanation}
                        <div className="challenge-figure">Featured: {challengeData.figure}</div>
                      </div>
                      <div className="challenge-example-section">
                        <div className="challenge-example-label">Know a real-world example? Share it for a bonus point:</div>
                        <textarea className="challenge-example-input" placeholder="Describe a real historical example…" value={challengeExample} onChange={e => setChallengeExample(e.target.value)} disabled={challengeExampleDone} />
                        {!challengeExampleDone
                          ? <button className="challenge-submit-example" onClick={submitChallengeExample}>Submit Example (+1 point)</button>
                          : <div style={{ fontFamily: "DM Mono,monospace", fontSize: 11, color: "var(--green)", marginTop: 6 }}>✓ Example submitted — +1 point awarded</div>
                        }
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <div className="challenge-card" style={{ textAlign: "center" }}>
                  <button style={{ background: "var(--gold)", color: "var(--navy)", border: "none", padding: "12px 32px", borderRadius: 8, fontFamily: "Cinzel,serif", fontSize: 14, fontWeight: 700, cursor: "pointer" }} onClick={loadChallenge}>Load Today's Challenge</button>
                </div>
              )}
            </div>
          </div>

        ) : page === "fullpicture" ? (
          /* FULL PICTURE */
          <div className="fp-page">
            <div className="fp-header">
              <div className="fp-title">🔎 Full Picture</div>
              <div className="fp-subtitle">Key facts only · No spin · Every claim sourced</div>
            </div>
            <div className="fp-body">
              <div className="fp-disclaimer">Full Picture uses AI with live web search to surface verified sourced facts stripped of opinion and political framing from all sides. Every fact includes a source link you can verify yourself.</div>
              {!isMember && fpGuestCount < GUEST_SEARCH_LIMIT && <div className="fp-guest-counter">Guest searches: <span>{fpGuestCount}/{GUEST_SEARCH_LIMIT}</span> — <span style={{ cursor: "pointer", textDecoration: "underline", color: "var(--muted-light)" }} onClick={() => setPage("auth")}>Sign up for unlimited</span></div>}
              {!isMember && fpGuestCount >= GUEST_SEARCH_LIMIT ? (
                <div className="fp-limit-notice">You've used your <span style={{ color: "var(--gold)" }}>{GUEST_SEARCH_LIMIT} free searches</span> this month.<br /><span style={{ cursor: "pointer", textDecoration: "underline", color: "var(--gold)" }} onClick={() => setPage("auth")}>Create a free account</span> for unlimited searches.</div>
              ) : (
                <div className="fp-search-box">
                  <input className="fp-input" placeholder="What do you want the full picture on?" value={fpQuery} onChange={e => setFpQuery(e.target.value)} onKeyDown={e => { if (e.key === "Enter") handleFPSearch(); }} />
                  <button className="fp-search-btn" onClick={handleFPSearch} disabled={fpLoading || !fpQuery.trim()}>{fpLoading ? "Searching…" : "Get Facts"}</button>
                </div>
              )}
              {fpLoading && <div className="fp-loading"><div className="fp-spinner" />SEARCHING ALL SOURCES · STRIPPING BIAS · VERIFYING FACTS…</div>}
              {fpError && <div className="fp-error">{fpError}</div>}
              {fpResults && !fpLoading && (
                <div className="fp-results">
                  <div className="fp-topic">{fpResults.topic}</div>
                  {fpResults.facts?.map((f, i) => (
                    <div key={i} className="fp-fact">
                      <div className="fp-fact-num">FACT {String(i + 1).padStart(2, "0")}</div>
                      <div className="fp-fact-text">{f.fact}</div>
                      <div className="fp-fact-source"><span className="fp-fact-source-label">Source:</span><a href={f.source_url} target="_blank" rel="noopener noreferrer">{f.source_name}</a></div>
                    </div>
                  ))}
                </div>
              )}
              {!fpResults && !fpLoading && !fpError && <div className="fp-empty">Type any topic and Full Picture will return only what is verified and sourced.<br /><br /><span style={{ fontSize: 13, color: "var(--muted)", fontFamily: "DM Mono,monospace", letterSpacing: "0.08em" }}>No opinions. No agendas. Just facts.</span></div>}
            </div>
          </div>

        ) : page === "journal" ? (
          /* JOURNAL */
          <div className="journal-page">
            <div className="journal-header">
              <div className="journal-header-top">
                <div><div className="journal-title-text">📖 My Journal</div><div className="journal-subtitle">Encrypted · Private · Yours Alone</div></div>
                {journalUnlocked && <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div className="journal-lock-badge">🔓 Unlocked</div>
                  <button onClick={() => { setJournalUnlocked(false); setJournalKey(""); setJournalKeyInput(""); setJournalEntries([]); setJournalView("list"); setJournalEditing(null); }} style={{ background: "transparent", border: "1px solid var(--border)", color: "var(--muted)", padding: "6px 14px", borderRadius: 20, fontFamily: "DM Mono,monospace", fontSize: 10, cursor: "pointer" }}>🔒 Lock</button>
                </div>}
              </div>
            </div>
            {!journalUnlocked ? (
              <div className="journal-unlock-screen">
                <div className="journal-unlock-icon">🔐</div>
                <div className="journal-unlock-title">Your Private Journal</div>
                <div className="journal-unlock-sub">AES-256 ENCRYPTED IN YOUR BROWSER.<br />NOT EVEN VERITAS CRUDA CAN READ YOUR ENTRIES.</div>
                <div className="journal-unlock-warning"><span>⚠ IMPORTANT:</span> If you forget your passphrase your entries cannot be recovered. There is no reset. First time? Pick any passphrase and start writing.</div>
                <input className="journal-key-input" type="password" placeholder="Enter your journal passphrase…" value={journalKeyInput} onChange={e => { setJournalKeyInput(e.target.value); setJournalError(""); }} onKeyDown={e => { if (e.key === "Enter") handleJournalUnlock(); }} />
                {journalError && <div className="journal-error">{journalError}</div>}
                <button className="journal-unlock-btn" onClick={handleJournalUnlock} disabled={journalUnlocking || !journalKeyInput.trim()}>{journalUnlocking ? "Unlocking…" : "Unlock Journal"}</button>
              </div>
            ) : (
              <div className="journal-body">
                {journalView === "list" ? (
                  <>
                    <div className="journal-toolbar">
                      <button className="journal-new-btn" style={{ margin: 0, padding: "8px 16px", fontSize: 12 }} onClick={() => { setJournalEditing(null); setJournalEditorTitle(""); setJournalEditorBody(""); setJournalSaveStatus(""); setJournalView("editor"); }}>✦ New Entry</button>
                      <button className="journal-download-btn" onClick={downloadJournalDocx}>📄 Download DOCX</button>
                    </div>
                    <div className="journal-list">
                      {journalEntries.length === 0
                        ? <div className="journal-empty">No entries yet.<br /><span style={{ fontSize: 13, color: "var(--muted)" }}>Your thoughts are safe here.</span></div>
                        : journalEntries.map(e => (
                          <div key={e.id} className="journal-entry-card" onClick={() => { setJournalEditing(e); setJournalEditorTitle(e.title); setJournalEditorBody(e.body); setJournalSaveStatus(""); setJournalView("editor"); }}>
                            <div className="journal-entry-date">{e.date}</div>
                            <div className="journal-entry-title">{e.title}</div>
                            <div className="journal-entry-preview">{e.body}</div>
                          </div>
                        ))
                      }
                    </div>
                  </>
                ) : (
                  <div className="journal-editor">
                    <button className="journal-editor-back" onClick={() => setJournalView("list")}>← Back to entries</button>
                    <input className="journal-editor-title" placeholder="Entry title…" value={journalEditorTitle} onChange={e => { setJournalEditorTitle(e.target.value); setJournalSaveStatus(""); }} />
                    <textarea className="journal-editor-body" placeholder="Write freely. No one else will ever read this…" value={journalEditorBody} onChange={e => { setJournalEditorBody(e.target.value); setJournalSaveStatus(""); }} />
                    <div className="journal-editor-actions">
                      <button className="journal-save-btn" onClick={handleJournalSave} disabled={journalSaveStatus === "saving"}>{journalSaveStatus === "saving" ? "Encrypting…" : "Save & Encrypt"}</button>
                      {journalEditing && <button className="journal-delete-btn" onClick={() => { saveJournal(loadJournal().filter(e => e.id !== journalEditing.id)); setJournalEntries(prev => prev.filter(e => e.id !== journalEditing.id)); setJournalView("list"); setJournalEditing(null); }}>Delete</button>}
                      {journalSaveStatus === "saved" && <span className="journal-saving done">✓ Encrypted & saved</span>}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

        ) : page === "profile" ? (
          /* PROFILE */
          <div className="profile-page">
            <div className="profile-main" style={{ position: "relative", backgroundImage: profileBgUrl ? `url(${profileBgUrl})` : "none", backgroundSize: "cover", backgroundPosition: "center", backgroundAttachment: "fixed" }}>
              {profileCss && <style>{profileCss}</style>}
              {profileBgUrl && <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 0, pointerEvents: "none" }} />}
              {profileMusicUrl && (
                <div style={{ padding: "12px 24px", background: "var(--navy-2)", borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center", gap: 12, position: "relative", zIndex: 1 }}>
                  <span style={{ fontSize: 12, fontFamily: "DM Mono,monospace", color: "var(--gold)", letterSpacing: "0.1em", flexShrink: 0 }}>♫ NOW PLAYING</span>
                  {profileMusicUrl.startsWith("audio:")
                    ? <audio controls autoPlay src={profileMusicUrl.replace("audio:", "")} style={{ flex: 1, height: 40, accentColor: "var(--gold)" }} />
                    : <iframe src={profileMusicUrl} width="100%" height="80" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen" style={{ borderRadius: 8, flex: 1 }} title="Profile Music" />
                  }
                </div>
              )}
              <div className="profile-banner" style={{ position: "relative", zIndex: 1 }}>
                {profileBanner && <img src={profileBanner} alt="banner" />}
                <label className="profile-banner-edit" style={{ cursor: "pointer" }}>
                  🖼 Edit Banner
                  <input type="file" accept="image/*" style={{ display: "none" }} onChange={e => { const f = e.target.files[0]; if (f) setProfileBanner(URL.createObjectURL(f)); }} />
                </label>
              </div>
              <div className="profile-info-bar" style={{ position: "relative", zIndex: 1 }}>
                <div className="profile-avatar-wrap">
                  <label className="profile-avatar-lg" style={{ borderColor: profileColor, boxShadow: `0 0 20px ${profileColor}66` }}>
                    {profilePhoto ? <img src={profilePhoto} alt="" /> : currentUser.avatar}
                    <input type="file" accept="image/*" style={{ display: "none" }} onChange={e => { const f = e.target.files[0]; if (f) setProfilePhoto(URL.createObjectURL(f)); }} />
                  </label>
                </div>
                <div className="profile-name" style={{ fontFamily: profileFont }}>{currentUser.name}</div>
                <div className="profile-handle">{currentUser.handle}</div>
                <div className="profile-badge-display">{userBadge.icon} {userBadge.label} · Score: {challengeScore}</div>
                {profileEditingBio
                  ? <textarea className="profile-bio-edit" value={profileBio} onChange={e => setProfileBio(e.target.value)} onBlur={() => setProfileEditingBio(false)} autoFocus />
                  : <div className="profile-bio" onClick={() => setProfileEditingBio(true)}>"{profileBio}"</div>
                }
                {profileWebsite && <a href={profileWebsite.startsWith("http") ? profileWebsite : "https://" + profileWebsite} target="_blank" rel="noopener noreferrer" className="profile-website">🔗 {profileWebsite}</a>}
                <div className="profile-stats">
                  <div className="stat"><div className="stat-num">0</div><div className="stat-label">Posts</div></div>
                  <div className="stat"><div className="stat-num">{isAdmin ? "∞" : "0"}</div><div className="stat-label">Followers</div></div>
                  <div className="stat"><div className="stat-num">0</div><div className="stat-label">Following</div></div>
                </div>
              </div>
              {showCustomize && (
                <div className="customize-panel" style={{ position: "relative", zIndex: 1 }}>
                  <div className="customize-header">✦ Profile Customization</div>
                  <div className="customize-body">
                    <div className="customize-row">
                      <div className="customize-label">Accent Color</div>
                      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <input type="color" value={profileColor} onChange={e => setProfileColor(e.target.value)} style={{ width: 48, height: 48, border: "2px solid var(--border)", borderRadius: 8, background: "none", cursor: "pointer", padding: 2 }} />
                        <span style={{ fontFamily: "DM Mono,monospace", fontSize: 13, color: "var(--muted-light)" }}>{profileColor.toUpperCase()}</span>
                        <div style={{ width: 32, height: 32, borderRadius: "50%", background: profileColor, boxShadow: `0 0 12px ${profileColor}88`, border: "2px solid var(--border)" }} />
                      </div>
                    </div>
                    <div className="customize-row">
                      <div className="customize-label">Profile Font</div>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                        {PROFILE_FONTS.map(f => <div key={f} className={`font-opt${profileFont === f ? " selected" : ""}`} style={{ fontFamily: f, fontSize: 14 }} onClick={() => setProfileFont(f)}>{f}</div>)}
                      </div>
                    </div>
                    <div className="customize-row">
                      <div className="customize-label">Layout</div>
                      <div className="layout-options">{PROFILE_LAYOUTS.map(l => <div key={l} className={`layout-opt${profileLayout === l ? " selected" : ""}`} onClick={() => setProfileLayout(l)}>{l}</div>)}</div>
                    </div>
                    <div className="customize-row">
                      <div className="customize-label">Website Link</div>
                      <input className="auth-input" style={{ fontSize: 13, padding: "8px 10px" }} placeholder="yourwebsite.com" value={profileWebsite} onChange={e => setProfileWebsite(e.target.value)} />
                    </div>
                    <div className="customize-row">
                      <div className="customize-label">Background Image</div>
                      <input type="file" accept="image/*" onChange={e => { const f = e.target.files[0]; if (f) { const u = URL.createObjectURL(f); setProfileBgUrl(u); setProfileBgInput(u); } }} style={{ fontFamily: "DM Mono,monospace", fontSize: 11, color: "var(--muted-light)", cursor: "pointer", marginBottom: 8 }} />
                      <div style={{ display: "flex", gap: 8 }}>
                        <input className="auth-input" style={{ fontSize: 12, padding: "8px 10px" }} placeholder="Or paste image URL…" value={profileBgInput} onChange={e => setProfileBgInput(e.target.value)} />
                        <button onClick={() => setProfileBgUrl(profileBgInput)} style={{ background: "var(--gold)", color: "var(--navy)", border: "none", padding: "8px 14px", borderRadius: 8, fontFamily: "DM Mono,monospace", fontSize: 11, cursor: "pointer", fontWeight: 700, flexShrink: 0 }}>SET</button>
                        {profileBgUrl && <button onClick={() => { setProfileBgUrl(""); setProfileBgInput(""); }} style={{ background: "transparent", color: "var(--muted)", border: "1px solid var(--border)", padding: "8px 10px", borderRadius: 8, fontFamily: "DM Mono,monospace", fontSize: 11, cursor: "pointer", flexShrink: 0 }}>✕</button>}
                      </div>
                    </div>
                    <div className="customize-row">
                      <div className="customize-label">Profile Music</div>
                      <div style={{ display: "flex", gap: 8 }}>
                        <input className="auth-input" style={{ fontSize: 12, padding: "8px 10px" }} placeholder="YouTube / Spotify / SoundCloud link…" value={profileMusicInput} onChange={e => setProfileMusicInput(e.target.value)} />
                        <button onClick={() => {
                          let u = profileMusicInput;
                          if (u.includes("spotify.com/track/")) { const id = u.split("track/")[1].split("?")[0]; u = `https://open.spotify.com/embed/track/${id}`; }
                          else if (u.includes("youtube.com/watch?v=")) { const id = u.split("v=")[1].split("&")[0]; u = `https://www.youtube.com/embed/${id}?autoplay=1`; }
                          else if (u.includes("youtu.be/")) { const id = u.split("youtu.be/")[1].split("?")[0]; u = `https://www.youtube.com/embed/${id}?autoplay=1`; }
                          setProfileMusicUrl(u);
                        }} style={{ background: "var(--gold)", color: "var(--navy)", border: "none", padding: "8px 14px", borderRadius: 8, fontFamily: "DM Mono,monospace", fontSize: 11, cursor: "pointer", fontWeight: 700, flexShrink: 0 }}>SET</button>
                        {profileMusicUrl && <button onClick={() => { setProfileMusicUrl(""); setProfileMusicInput(""); }} style={{ background: "transparent", color: "var(--muted)", border: "1px solid var(--border)", padding: "8px 10px", borderRadius: 8, fontFamily: "DM Mono,monospace", fontSize: 11, cursor: "pointer", flexShrink: 0 }}>✕</button>}
                      </div>
                    </div>
                    <div className="customize-row">
                      <div className="customize-label">Upload Audio File</div>
                      <input type="file" accept="audio/*" onChange={e => { const f = e.target.files[0]; if (f) setProfileMusicUrl("audio:" + URL.createObjectURL(f)); }} style={{ fontFamily: "DM Mono,monospace", fontSize: 11, color: "var(--muted-light)", cursor: "pointer" }} />
                    </div>
                    <div className="customize-row">
                      <div className="customize-label">CSS Editor <span style={{ color: "var(--muted)", fontSize: 10 }}>(Advanced · 16+ only)</span></div>
                      <div style={{ fontSize: 11, color: "var(--muted)", fontFamily: "DM Mono,monospace", marginBottom: 6, letterSpacing: "0.06em", lineHeight: 1.6 }}>Paste custom CSS to deeply personalize your profile and TRIBUNA Voice page. Changes apply live.</div>
                      <textarea className="css-editor" placeholder={"/* Your custom CSS */\n.profile-name { color: #FF6B6B; }\n.profile-banner { background: linear-gradient(...); }"} value={profileCss} onChange={e => setProfileCss(e.target.value)} />
                      <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
                        <button onClick={() => setProfileCss("")} style={{ background: "transparent", color: "var(--muted)", border: "1px solid var(--border)", padding: "6px 14px", borderRadius: 6, fontFamily: "DM Mono,monospace", fontSize: 11, cursor: "pointer" }}>Reset CSS</button>
                        {profileCss && <span style={{ fontFamily: "DM Mono,monospace", fontSize: 10, color: "var(--green)", display: "flex", alignItems: "center", gap: 4 }}>✓ Active</span>}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div style={{ padding: "40px 24px", textAlign: "center", color: "var(--muted)", fontStyle: "italic", fontSize: 15, position: "relative", zIndex: 1 }}>No posts yet. Speak the raw truth.</div>
            </div>

            {/* ADMIN PANEL */}
            {isAdmin && (
              <div className="admin-panel">
                <div className="admin-panel-header"><span className="admin-panel-title">⚡ Admin Overview</span></div>
                <div className="admin-stat-grid">
                  <div className="admin-stat-box"><div className="admin-stat-box-num">{users.length}</div><div className="admin-stat-box-label">Users</div></div>
                  <div className="admin-stat-box"><div className="admin-stat-box-num">{users.filter(u => u.isOrg).length}</div><div className="admin-stat-box-label">Orgs</div></div>
                  <div className="admin-stat-box"><div className="admin-stat-box-num">{adminPosts.length}</div><div className="admin-stat-box-label">Posts</div></div>
                  <div className="admin-stat-box"><div className="admin-stat-box-num" style={{ color: users.filter(u => u.banned).length > 0 ? "var(--red)" : "var(--green)" }}>{users.filter(u => u.banned).length}</div><div className="admin-stat-box-label">Banned</div></div>
                </div>
                {pendingReports > 0 && (
                  <>
                    <div className="admin-section-title" style={{ color: "var(--red)" }}>⚠ Pending Reports ({pendingReports})</div>
                    {reports.filter(r => r.status === "pending").map(r => (
                      <div key={r.id} className="report-queue-item">
                        <div className="report-queue-meta"><span className="report-queue-from">From: {r.from}</span><span className="report-queue-against">Against: {r.against}</span></div>
                        <div className="report-queue-desc">{r.desc}</div>
                        {r.link && <div className="report-queue-link">🔗 {r.link}</div>}
                        {r.screenshot && <div className="report-queue-link">📸 {r.screenshot}</div>}
                        <div className="report-queue-actions">
                          <button className="report-approve-btn" onClick={() => approveReport(r.id)}>Approve</button>
                          <button className="report-dismiss-btn" onClick={() => dismissReport(r.id)}>Dismiss</button>
                        </div>
                      </div>
                    ))}
                  </>
                )}
                <div className="admin-section-title">Members</div>
                {users.map(u => (
                  <div key={u.id} className="admin-user-row">
                    <div className="admin-mini-avatar">{u.avatar}</div>
                    <div style={{ flex: 1, overflow: "hidden" }}><div className="admin-mini-name" style={{ opacity: u.banned ? 0.5 : 1 }}>{u.name}</div><div className="admin-mini-handle">{u.handle}</div></div>
                    {u.isOrg && <span className="admin-mini-badge org">ORG</span>}
                    {u.banned && <span className="admin-mini-badge banned">BAN</span>}
                    {violations[u.handle] && <span style={{ fontSize: 9, fontFamily: "DM Mono,monospace", color: "var(--red)" }}>{violations[u.handle].count}v</span>}
                    <button className={u.banned ? "mini-unban-btn" : "mini-ban-btn"} onClick={() => toggleBan(u.id)}>{u.banned ? "Unban" : "Ban"}</button>
                  </div>
                ))}
                <div className="admin-section-title">Recent Posts</div>
                {adminPosts.slice(0, 5).map(p => (
                  <div key={p.id} className="admin-post-row">
                    <div className="admin-post-meta"><span className="admin-post-user">{p.user}</span><span className="admin-post-time">{p.time}</span></div>
                    <div className="admin-post-text">{p.body}</div>
                    <button className="mini-delete-btn" onClick={() => deletePost(p.id)}>Delete</button>
                  </div>
                ))}
              </div>
            )}
          </div>

        ) : (
          /* FEED */
          <div className="feed-col">
            <div className="feed-header">
              <div className="feed-header-top">
                <h2>Veritas Cruda</h2>
                <div style={{ display: "flex", gap: 6 }}>
                  <button className={`feed-sort-btn${feedSort === "latest" ? " active" : ""}`} onClick={() => setFeedSort("latest")}>Latest</button>
                  <button className={`feed-sort-btn${feedSort === "foryou" ? " active" : ""}`} onClick={() => setFeedSort("foryou")}>For You</button>
                </div>
              </div>
              <div className="feed-tabs">
                {["For You", "Following", "Media"].map(t => (
                  <div key={t} className={`feed-tab${feedTab === t ? " active" : ""}`} onClick={() => setFeedTab(t)}>{t}</div>
                ))}
              </div>
            </div>
            <div className="compose">
              <div className="compose-avatar">{profilePhoto ? <img src={profilePhoto} alt="" /> : currentUser.avatar}</div>
              <div className="compose-right">
                <textarea ref={composeRef} className="compose-input" placeholder="Speak the raw truth… use @handle to tag someone" value={composeText} onChange={handleComposeChange} />
                {tagSuggestions.length > 0 && (
                  <div className="tag-suggestions">
                    {tagSuggestions.map(u => (
                      <div key={u.handle} className="tag-suggestion-item" onClick={() => insertTag(u.handle)}>
                        <span style={{ fontSize: 16 }}>{u.avatar}</span>
                        <div><div className="tag-suggestion-name">{u.name}</div><div className="tag-suggestion-handle">{u.handle}</div></div>
                      </div>
                    ))}
                  </div>
                )}
                {showPollBuilder && (
                  <div className="poll-builder">
                    <div className="poll-builder-title">📊 Poll Options</div>
                    {pollOptions.map((opt, i) => (
                      <input key={i} className="poll-option-input" placeholder={`Option ${i + 1}${i < 2 ? " (required)" : " (optional)"}`} value={opt} onChange={e => { const o = [...pollOptions]; o[i] = e.target.value; setPollOptions(o); }} />
                    ))}
                    <div className="poll-duration">
                      {["24h", "48h", "7d"].map(d => <button key={d} className={`poll-dur-btn${pollDuration === d ? " active" : ""}`} onClick={() => setPollDuration(d)}>{d}</button>)}
                    </div>
                  </div>
                )}
                <div className="compose-actions">
                  <div className="compose-tools">
                    <button className="compose-tool" title="Photo">📷</button>
                    <button className="compose-tool" title="Video">🎥</button>
                    <button className="compose-tool" title="Link">🔗</button>
                    <button className="compose-tool" title="Poll" onClick={() => setShowPollBuilder(!showPollBuilder)}>📊</button>
                    <label className="compose-anon"><input type="checkbox" checked={composeAnon} onChange={e => setComposeAnon(e.target.checked)} /> Anon</label>
                  </div>
                  <button className="post-btn" onClick={submitPost}>Post</button>
                </div>
              </div>
            </div>
            <div className="scrollable">
              {feedPosts.map(post => <PostCard key={post.id} post={post} onLike={toggleLike} onReport={openReport} onSave={toggleSave} onVotePoll={votePoll} savedPosts={savedPosts} currentUser={currentUser} />)}
            </div>
          </div>
        )}

        {/* RIGHT COLUMN */}
        <div className="right-col">
          {quoteData && (
            <div className="quote-widget">
              <div className="widget-header">📜 Freedom Quote of the Day</div>
              <div className="quote-body">"{quoteData.quote}"</div>
              <div className="quote-author">— {quoteData.author}, {quoteData.year}</div>
            </div>
          )}
          <div className="widget">
            <div className="widget-header">⚡ Trending</div>
            <div className="trend-item"><div className="trend-tag">#VeritasCruda</div><div className="trend-count">New platform · Join the conversation</div></div>
            <div className="trend-item"><div className="trend-tag">#FreedomChallenge</div><div className="trend-count">Answer today's question</div></div>
            <div className="trend-item"><div className="trend-tag">#RawTruth</div><div className="trend-count">Unfiltered</div></div>
            <div className="trend-item"><div className="trend-tag">#TRIBUNA</div><div className="trend-count">Where Voices Stand</div></div>
          </div>
          <div className="widget">
            <div className="widget-header">🏆 Challenge Leaders</div>
            <div className="leaderboard-item">
              <div style={{ fontFamily: "DM Mono,monospace", fontSize: 11, color: "var(--muted)", width: 20 }}>1</div>
              <div style={{ flex: 1, fontSize: 13, color: "var(--off-white)" }}>@ViveLiber</div>
              <div style={{ fontFamily: "DM Mono,monospace", fontSize: 11, color: "var(--gold)" }}>🔥 Founder</div>
            </div>
            <div style={{ padding: "10px 16px", fontFamily: "DM Mono,monospace", fontSize: 10, color: "var(--muted)", letterSpacing: "0.08em", textAlign: "center" }}>Answer today's challenge to appear on the board</div>
          </div>
          <div className="widget">
            <div className="widget-header">✦ Suggested Voices</div>
            <div className="suggest-item">
              <div className="suggest-avatar">👑</div>
              <div><div className="suggest-name">Jacks Liver</div><div className="suggest-handle">@ViveLiber</div></div>
              <button className={`follow-btn${followedUsers.includes("@ViveLiber") ? " following" : ""}`} onClick={() => toggleFollow("@ViveLiber")}>
                {followedUsers.includes("@ViveLiber") ? "Following" : "Follow"}
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
    </>
  );
}
